<template>
    <div class="pageRegisterLink" :class="{ 'pageRegisterLink--supplement': supplementMode }">
        <div class="page-head" v-if="!supplementMode">
            <div class="jobMain">
                <div class="page-tle"><i class="el-icon-office-building iconStyle"></i>专业申报</div>
            </div>
        </div>
        <div class="pageReg-main" v-if="!supplementMode">
            <div class="jobMain">
                <el-row :gutter="24">
                    <el-col :span="6" v-if="normalizedTalentType === 0">
                        <div class="pageReg-ml">
                            <div class="pageReg-ml-t">
                                <div class="pageReg-ml-tle">选择专业类别</div>
                                <div><el-input
                                    placeholder="输入专业类别筛选..."
                                    prefix-icon="el-icon-search"
                                    v-model="majorCategorySearch"
                                    clearable>
                                </el-input></div>
                            </div>
                            <div class="pageReg-ml-list">
                                <ul>
                                    <li :class="selectedMajorCategory === '' ? 'active' : ''" @click="selectMajorCategory('')">全部</li>
                                    <li
                                        v-for="(cat, index) in filteredMajorCategoryOptions"
                                        :key="'cat-' + index"
                                        :class="selectedMajorCategory === cat ? 'active' : ''"
                                        @click="selectMajorCategory(cat)"
                                    >{{ cat }}</li>
                                </ul>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6" v-else-if="normalizedTalentType === 1">
                        <div class="pageReg-ml">
                            <div class="pageReg-ml-t">
                                <div class="pageReg-ml-tle">选择专业名称</div>
                                <div><el-input
                                    placeholder="输入专业名称筛选..."
                                    prefix-icon="el-icon-search"
                                    v-model="majorNameSearch"
                                    clearable>
                                </el-input></div>
                            </div>
                            <div class="pageReg-ml-list">
                                <ul>
                                    <li :class="selectedMajorName === '' ? 'active' : ''" @click="selectMajorName('')">全部</li>
                                    <li
                                        v-for="(name, index) in filteredMajorNameOptions"
                                        :key="'major-' + index"
                                        :class="selectedMajorName === name ? 'active' : ''"
                                        @click="selectMajorName(name)"
                                    >{{ name }}</li>
                                </ul>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="rightColSpan">
                        <div class="pageReg-banner" :style="{ backgroundImage: 'url(' + pageBannerImg + ')' }">
                            <div class="pageReg-banner-left">
                                <div class="pageReg-banner-lname">{{ bannerFilterTitle }}</div>
                                <div class="pageReg-banner-lb">
                                    <span class="pageReg-banner-num"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M8 10.5V9.5C8 8.96957 7.78929 8.46086 7.41421 8.08579C7.03914 7.71071 6.53043 7.5 6 7.5H3C2.46957 7.5 1.96086 7.71071 1.58579 8.08579C1.21071 8.46086 1 8.96957 1 9.5V10.5" stroke="#4A5565" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 1.56396C8.42888 1.67515 8.8087 1.9256 9.07984 2.276C9.35098 2.6264 9.4981 3.05691 9.4981 3.49996C9.4981 3.94302 9.35098 4.37353 9.07984 4.72393C8.8087 5.07433 8.42888 5.32478 8 5.43596" stroke="#4A5565" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11 10.4999V9.49994C10.9997 9.05681 10.8522 8.62633 10.5807 8.2761C10.3092 7.92587 9.92906 7.67573 9.5 7.56494" stroke="#4A5565" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M4.5 5.5C5.60457 5.5 6.5 4.60457 6.5 3.5C6.5 2.39543 5.60457 1.5 4.5 1.5C3.39543 1.5 2.5 2.39543 2.5 3.5C2.5 4.60457 3.39543 5.5 4.5 5.5Z" stroke="#4A5565" stroke-linecap="round" stroke-linejoin="round"/>
</svg> 报名 {{ curCompN.bm }} 人</span>
                                    <span class="pageReg-banner-num"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M8 10.5V9.5C8 8.96957 7.78929 8.46086 7.41421 8.08579C7.03914 7.71071 6.53043 7.5 6 7.5H3C2.46957 7.5 1.96086 7.71071 1.58579 8.08579C1.21071 8.46086 1 8.96957 1 9.5V10.5" stroke="#4A5565" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 1.56396C8.42888 1.67515 8.8087 1.9256 9.07984 2.276C9.35098 2.6264 9.4981 3.05691 9.4981 3.49996C9.4981 3.94302 9.35098 4.37353 9.07984 4.72393C8.8087 5.07433 8.42888 5.32478 8 5.43596" stroke="#4A5565" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11 10.4999V9.49994C10.9997 9.05681 10.8522 8.62633 10.5807 8.2761C10.3092 7.92587 9.92906 7.67573 9.5 7.56494" stroke="#4A5565" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M4.5 5.5C5.60457 5.5 6.5 4.60457 6.5 3.5C6.5 2.39543 5.60457 1.5 4.5 1.5C3.39543 1.5 2.5 2.39543 2.5 3.5C2.5 4.60457 3.39543 5.5 4.5 5.5Z" stroke="#4A5565" stroke-linecap="round" stroke-linejoin="round"/>
</svg> 审核 {{ curCompN.sp }} 人</span>
                                </div>
                            </div>
                            <template v-if="false">
                                <div class="pageReg-banner-right">
                                    <div class="pageReg-banner-rt">咨询电话</div>
                                    <div class="pageReg-banner-tel"><i class="el-icon-phone" style="color: #E7000B"></i> {{curComp.phone}}</div>
                                </div>
                            </template>
                        </div>
                        <div class="pageReg-rm">
                            <template v-if="false">
                                <div class="pageReg-rmt">单位简介</div>
                                <div class="pageReg-rm-intro">{{curComp.introduction}}</div>
                            </template>
                            <div class="pageReg-rmt">在招专业 <span class="jobNum" v-if="displayJobData.total">{{displayJobData.total}}</span></div>
                            <el-radio-group
                                v-if="normalizedTalentType === 2"
                                v-model="activeWorkTypeTab"
                                size="small"
                                class="pageReg-work-tabs">
                                <el-radio-button label="0">煤矿井下一线</el-radio-button>
                                <el-radio-button label="1">化工生产一线</el-radio-button>
                            </el-radio-group>
                            <div v-if="displayJobData.total > 0">
                                <el-row :gutter="20">
                                    <el-col :span="12" v-for="(item,index) in displayJobData.records" :key="'job-' + activeWorkTypeTab + '-' + (item.id || index)">
                                        <div class="jobLi" :class="{'jobLi--tech': normalizedTalentType === 1}">
                                            <div class="jobLi-tle">{{ formatCardTitle(item) }}</div>
                                            <div class="tagParent"><el-tag class="tagDom" type="success">{{ recruitTagLabel }}</el-tag></div>
                                            <div>
                                                <el-row class="jobLi-condition-row">
                                                    <el-col :span="12" v-if="normalizedTalentType !== 1">
                                                        <div class="job-condition">
                                                            <div class="job-condition-t"><i class="el-icon-suitcase-1 job-icon"></i> 专业要求</div>
                                                            <div class="job-condition-b">{{ formatMajorRequirement(item) }}</div>
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <div class="job-condition">
                                                            <div class="job-condition-t"><span v-html="jobHat"></span> 学历条件</div>
                                                            <div class="job-condition-b">{{ formatEducation(item.educationRequire) }}</div>
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12" v-if="normalizedTalentType === 1">
                                                        <div class="job-condition">
                                                            <div class="job-condition-t"><i class="el-icon-document job-icon"></i> 专业代码</div>
                                                            <div class="job-condition-b">{{ item.undergraduateMajorCode || '—' }}</div>
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <div class="job-condition">
                                                            <div class="job-condition-t"><i class="el-icon-time job-icon"></i> 毕业年限要求</div>
                                                            <div class="job-condition-b">{{ item.graduationYearsRequirement || '—' }}</div>
                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                            <div><button class="pageReg-bm-btn" :class="{ 'pageReg-bm-btn--disabled': isRegisterDisabled }" :disabled="isRegisterDisabled" @click="openReg(item)">立即报名 <i class="el-icon-right"></i></button></div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <div v-else style="font-size: 20px; text-align: center; padding-top: 30px; color: #999;">暂无数据！</div>
                            <div v-if="displayJobData.total > 0">
                                <el-pagination
                                    background
                                    :current-page="displayJobData.current"
                                    layout="total, prev, pager, next"
                                    @current-change="changePage"
                                    :total="displayJobData.total">
                                </el-pagination>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div v-if="supplementMode" class="supplement-form-panel">
            <div class="supplement-form-toolbar">
                <span class="supplement-form-title">资料修改</span>
                <span v-if="bmObj.positionsName" class="supplement-form-major">{{ bmObj.positionsName }}</span>
            </div>
            <div class="supplement-form-scroll">
                <reg-application-form-fields />
            </div>
            <div class="supplement-form-footer">
                <div class="regJob-dom supplement-commitment">
                    <el-radio v-model="bmObj.isCommitted" :label="1">本人承诺所填报的全部内容真实有效，按要求仅报考一个单位。若刻意隐瞒或遗漏任何影响公司作出正确判断的重大事项，本人愿承担全部责任。</el-radio>
                </div>
                <el-button type="danger" :loading="submitting" :disabled="submitting || isSupplementSubmitDisabled" @click="createBm">提交补充资料</el-button>
                <div v-if="isSupplementSubmitDisabled" class="supplement-closed-tip">当前不在报名开放时间内，暂无法提交补充资料</div>
            </div>
        </div>
        <el-dialog
            v-else
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="70%"
            :before-close="closeReg"
            :close-on-click-modal="!submitting"
            :close-on-press-escape="!submitting"
            :show-close="!submitting"
        >
            <div v-loading="submitting" element-loading-text="正在保存，请稍候...">
                <reg-application-form-fields />
                <div class="regJob-dom" style="padding: 15px;">
                    <el-radio v-model="bmObj.isCommitted" :label="1">本人承诺所填报的全部内容真实有效，按要求仅报考一个单位。若刻意隐瞒或遗漏任何影响公司作出正确判断的重大事项，本人愿承担全部责任。</el-radio>
                </div>
                <div class="regJob-dom">
                    <el-button type="danger" :loading="submitting" :disabled="submitting" @click="createBm">保存</el-button>
                    <el-button :disabled="submitting" @click="dialogVisible=false">取消</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            title="报名成功"
            :visible.sync="regSuccessDialogVisible"
            width="720px"
            top="12vh"
            custom-class="reg-success-dialog"
            :close-on-click-modal="false">
            <div class="reg-success-subtitle">请按以下流程完成签字</div>
            <div class="reg-success-body">
                <div class="reg-success-head">
                    <i class="el-icon-success reg-success-icon"></i>
                    <div class="reg-success-title">报名信息已保存</div>
                </div>
                <div class="reg-success-flow">
                    <div class="reg-success-step reg-success-step--done">
                        <div class="reg-success-step-num">1</div>
                        <div class="reg-success-step-text">保存报名信息</div>
                        <div class="reg-success-step-tag">已完成</div>
                    </div>
                    <div class="reg-success-arrow"><i class="el-icon-right"></i></div>
                    <div class="reg-success-step reg-success-step--active">
                        <div class="reg-success-step-num">2</div>
                        <div class="reg-success-step-text">前往「我的应聘」</div>
                    </div>
                    <div class="reg-success-arrow"><i class="el-icon-right"></i></div>
                    <div class="reg-success-step">
                        <div class="reg-success-step-num">3</div>
                        <div class="reg-success-step-text">核对确认信息</div>
                    </div>
                    <div class="reg-success-arrow"><i class="el-icon-right"></i></div>
                    <div class="reg-success-step">
                        <div class="reg-success-step-num">4</div>
                        <div class="reg-success-step-text">完成签字提交</div>
                    </div>
                </div>
                <div class="reg-success-tip">
                    <i class="el-icon-warning-outline"></i>
                    下一步：点击顶部导航栏 <b>「我的应聘」</b>，核对信息无误后在页面底部完成签字。
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="regSuccessDialogVisible = false">我知道了</el-button>
                <el-button type="danger" @click="goToMyJobAfterReg">前往我的应聘</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import md5 from 'js-md5'
import moment from "moment";
import {
    normalizeGraduationYearForPicker,
    toGraduationYearStorage,
} from '../utils/graduationDate';
import RegApplicationFormFields from './RegApplicationFormFields.vue';

export default {
    name: 'PageRegLink',
    components: {
        RegApplicationFormFields,
    },
    props: {
        supplementMode: {
            type: Boolean,
            default: false,
        },
        supplementData: {
            type: Object,
            default: null,
        },
    },
    provide() {
        return { regLink: this };
    },
    data() {
        return {
            queryData: {
                current: 1,
                size: 10,
            },
            userInfo: {},
            talentBannerMap: {
                0: 'https://webimg.mp12345.com/b2b/enquiry/file/2026/05/25/3nr79kg0obiyhirova033fbbmwop459e.png',
                1: 'https://webimg.mp12345.com/b2b/enquiry/file/2026/05/25/zbbd2dujohexi8mv4iith71oaiexgdxn.png',
                2: 'https://webimg.mp12345.com/b2b/enquiry/file/2026/05/25/sdsv8kkv4ci61d7dsjfucotap8noozlc.png',
            },
            jobType: {0:"校园招聘",1:"招工招聘",2:"内部选聘",3:"社会招聘",4:"其他招聘"},
            talentType: null,
            allJobList: [],
            selectedMajorCategory: '',
            selectedMajorName: '',
            majorCategorySearch: '',
            majorNameSearch: '',
            workTypeMap: {0: '煤矿井下一线', 1: '化工生产一线'},
            activeWorkTypeTab: '0',
            workTypePage: {0: 1, 1: 1},
            jobHat: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 12 12" fill="none"><g clip-path="url(#clip0_674_6191)"><path d="M10.71 5.46118C10.7995 5.42169 10.8755 5.35681 10.9285 5.27458C10.9815 5.19235 11.0092 5.09637 11.0082 4.99855C11.0072 4.90072 10.9775 4.80534 10.9228 4.72422C10.8681 4.6431 10.7908 4.57981 10.7005 4.54218L6.41502 2.59018C6.28474 2.53075 6.14322 2.5 6.00002 2.5C5.85683 2.5 5.7153 2.53075 5.58502 2.59018L1.30002 4.54018C1.21101 4.57916 1.13528 4.64325 1.0821 4.72459C1.02893 4.80593 1.00061 4.901 1.00061 4.99818C1.00061 5.09536 1.02893 5.19043 1.0821 5.27177C1.13528 5.35311 1.21101 5.41719 1.30002 5.45618L5.58502 7.41018C5.7153 7.4696 5.85683 7.50036 6.00002 7.50036C6.14322 7.50036 6.28474 7.4696 6.41502 7.41018L10.71 5.46118Z" stroke="#99A1AF" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 5V8" stroke="#99A1AF" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 6.25V8C3 8.39782 3.31607 8.77936 3.87868 9.06066C4.44129 9.34196 5.20435 9.5 6 9.5C6.79565 9.5 7.55871 9.34196 8.12132 9.06066C8.68393 8.77936 9 8.39782 9 8V6.25" stroke="#99A1AF" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_674_6191"><rect width="12" height="12" fill="white"/></clipPath></defs></svg>',
            dialogVisible: false,
            dialogTitle: '',
            files: {f1: null, f2: null, f3: null, f4: null, f5: null, f6: null, f7: null, f9: null},
            country: [{label: '中国', value: '中国'}],
            citys: [],
            currentCities: [],
            politicalStatusList: [
                {label:"中共党员", value: 1},
                {label:"中共预备党员", value: 2},
                {label:"共青团员", value: 3},
                {label:"民革成员", value: 4},
                {label:"民盟成员", value: 5},
                {label:"民建成员", value: 6},
                {label:"民进成员", value: 7},
                {label:"农工党成员", value: 8},
                {label:"致公党成员", value: 9},
                {label:"九三学社社员", value: 10},
                {label:"台盟成员", value: 11},
                {label:"无党派人士", value: 12},
                {label:"群众", value: 13}
            ],
            bmObj: {
                userId: '',
                name: '',   //姓名
                gender: 1,      //性别,0-女,1-男,2-其他
                phone: '',  //手机号
                birthDate: '',  //出生日期
                // residentCountryRegion: '中国',  //常住国家地区
                residentProvinceCity: '',   //当前居住省市
                residentCity: '',       //常住城市名称
                email: '',  //电子邮箱
                politicalStatus: null,    //政治面貌：1-中共党员 … 13-群众；初始不默认，由用户选择
                idCardNumber: '',   //身份证号
                nativePlace: '',   //籍贯
                address: '',    //常住地址
                graduatedInstitution: '',    //毕业院校
                institutionType: '',    //院校类别,如：985/211/双一流/普通本科等
                major: '',      //所学专业
                education: '',      //学历
                highestEducation: '',   //最高学历：专科、本科、硕士研究生、博士研究生
                admissionBatch: '',     //录取批次
                universityTime: '',     //升入大学时间
                graduationTime: '',    //毕业时间
                profileCompletion: '',      //资料完整度,百分比,0-100
                isCommitted: 1,       //是否签署承诺,0-未签署,1-已签署
                approvalStatus: 0,     //审批状态：0-待签名,1-需补充资料,2-审批中,3-已通过,4-审核不通过
                isDeleted: 0,      //是否删除,0-未删除,1-已删除
                photoUrl: '',  //照片地址
                applicationHtml: '',       //报名表HTML内容,使用LONGTEXT以存储大量数据
                positionId: '',      //recruit_position_info 表 ID
                recruitPositionInfoId: null,  //与 positionId 相同，报名卡片 id
                positionsName: '',    //应聘专业（相关专业）
                approvalComment: '',    //审批意见
                fillMethod: 0,     //填写方式:0-网页端,1-煤婆新消息,2-微信小程序,3-其他
                jobApplicationAttachmentList: [],      //附件列表,具体参数看应聘报名附件相关接口
                familyMemberList: [],      //家庭成员列表,具体参数看应聘报名家庭成员信息相关接口
                workExperienceList: [],     //工作经历列表,具体参数看应聘报名工作经历信息相关接口
                educationHistoryList: [],   //多段学历明细
                entrance_type: 0,  //0:优培人才、1:技术人才、2:操作人才
                workType: null,       // 操作人才：0煤矿井下一线 1化工生产一线
                majorCategory: '',    // 操作人才：专业类别
            },
            /** OCR 反显到非空时锁定输入；反显为空则允许手填，且手填后不会因内容变非空而误锁 */
            prefilledReadonly: {
                graduatedInstitution: false,
                major: false,
                education: false,
            },
            // work: [{jobDuties: '', companyName: '', startDate: '', endDate: '', jobDescription: '', now: false}],
            family: [
                {relationType: 0, name: '', mobile: '', workUnit: '', position: '', birthDate: '', isInLuan: 0},
                {relationType: 1, name: '', mobile: '', workUnit: '', position: '', birthDate: '', isInLuan: 0},
            ],
            relationType: {0:"父亲",1:"母亲",2:"配偶",3:"子女",4:"兄弟",5:"姐妹",6:"其他"},
            relationTypes: [
                {label:"父亲", value: 0},
                {label:"母亲", value: 1},
                {label:"配偶", value: 2},
                {label:"子女", value: 3},
                {label:"兄弟", value: 4},
                {label:"姐妹", value: 5},
                {label:"其他", value: 6}
            ],
            isInLuan: {0: '否', 1: '是'},
            sex: {0: '女', 1: '男', 2: '其他'},
            isBm: 0,
            entryList: [],
            isEntranceOpen: true,
            curCompN: {sp: 0, bm: 0},
            educationRecords: [],
            institutionLevelList: [
                {label: '985', value: '985'},
                {label: '211', value: '211'},
                {label: '双一流', value: '双一流'},
                {label: '普通院校', value: '普通院校'},
            ],
            certFileAccept: 'application/pdf,image/png,image/jpeg,image/jpg,image/bmp,image/gif',
            /** key: entranceType_highestEducation_segmentType，value: 0|1 */
            xuexinOcrConfigMap: {},
            submitting: false,
            regSuccessDialogVisible: false,
            supplementApplicationId: null,
            /** 用户手动改过性别后，身份证 OCR 不再覆盖 gender */
            genderManuallySet: false,
        }
    },
    mounted() {
        if (this.supplementMode) {
            document.title = '潞安招聘-补充资料';
            this.loadEntranceList();
            this.getUserInfo();
            this.loadXuexinOcrConfig();
            this.getAllCity();
            if (this.supplementData) {
                this.hydrateFromSupplementData(this.supplementData);
            }
            return;
        }
        document.title = '潞安招聘-报名链接';
        this.loadEntranceList();
        this.getUserInfo();
        this.loadXuexinOcrConfig();
        this.getAllCity();
        this.getJobInfo();
    },
    computed: {
        querySearch() {
            return this.$route.query.q || '';
        },
        /** 与登录页入口一致：0优培 1技术 2操作 */
        resolvedEntranceType() {
            if (this.normalizedTalentType != null) {
                return this.normalizedTalentType;
            }
            const t = this.bmObj.entrance_type;
            return t === '' || t === null || t === undefined ? null : Number(t);
        },
        highestEducationList() {
            return this.getHighestEducationOptionsByEntrance(this.resolvedEntranceType);
        },
        /** 技术人才入口且最高学历为本科 */
        needsTechUndergradMajorCode() {
            return this.resolvedEntranceType === 1 && this.bmObj.highestEducation === '本科';
        },
        normalizedTalentType() {
            if (this.talentType === null || this.talentType === undefined || this.talentType === '') {
                return null;
            }
            return Number(this.talentType);
        },
        rightColSpan() {
            return this.normalizedTalentType === 2 ? 24 : 18;
        },
        pageBannerImg() {
            const type = this.normalizedTalentType;
            if (type != null && this.talentBannerMap[type]) {
                return this.talentBannerMap[type];
            }
            return this.talentBannerMap[0];
        },
        bannerFilterTitle() {
            if (this.normalizedTalentType === 0) {
                return this.selectedMajorCategory || '全部';
            }
            if (this.normalizedTalentType === 1) {
                return this.selectedMajorName || '全部';
            }
            if (this.normalizedTalentType === 2) {
                const key = Number(this.activeWorkTypeTab);
                return this.workTypeMap[key] != null ? this.workTypeMap[key] : '全部';
            }
            return '全部';
        },
        recruitTagLabel() {
            const map = {0: '优培人才', 1: '技术人才', 2: '操作人才'};
            return map[this.normalizedTalentType] != null ? map[this.normalizedTalentType] : '招聘';
        },
        majorCategoryOptions() {
            return this.buildOptionsSortedByMinId((item) => item.majorCategory);
        },
        filteredMajorCategoryOptions() {
            const keyword = (this.majorCategorySearch || '').trim();
            if (!keyword) {
                return this.majorCategoryOptions;
            }
            return this.majorCategoryOptions.filter((cat) => cat.indexOf(keyword) !== -1);
        },
        majorNameOptions() {
            return this.buildOptionsSortedByMinId((item) => this.getUndergraduateMajorName(item));
        },
        filteredMajorNameOptions() {
            const keyword = (this.majorNameSearch || '').trim();
            if (!keyword) {
                return this.majorNameOptions;
            }
            return this.majorNameOptions.filter((name) => name.indexOf(keyword) !== -1);
        },
        filteredJobList() {
            let list = this.allJobList.slice();
            if (this.normalizedTalentType === 0 && this.selectedMajorCategory) {
                list = list.filter((item) => item.majorCategory === this.selectedMajorCategory);
            }
            if (this.normalizedTalentType === 1 && this.selectedMajorName) {
                list = list.filter((item) => this.getUndergraduateMajorName(item) === this.selectedMajorName);
            }
            if (this.normalizedTalentType === 2) {
                const workTypeKey = Number(this.activeWorkTypeTab);
                list = list.filter((item) => this.resolveWorkTypeKey(item.workType) === workTypeKey);
            }
            const keyword = (this.querySearch || '').trim();
            if (keyword) {
                list = list.filter((item) => {
                    if (this.normalizedTalentType === 1) {
                        return (this.getUndergraduateMajorName(item) || '').indexOf(keyword) !== -1;
                    }
                    if (this.normalizedTalentType === 2) {
                        return (item.majorName || '').indexOf(keyword) !== -1
                            || (item.majorCategory || '').indexOf(keyword) !== -1
                            || this.workTypeLabel(item.workType).indexOf(keyword) !== -1;
                    }
                    return (item.majorName || '').indexOf(keyword) !== -1
                        || (item.majorCategory || '').indexOf(keyword) !== -1;
                });
            }
            return list;
        },
        displayJobData() {
            const total = this.filteredJobList.length;
            const current = this.normalizedTalentType === 2
                ? (this.workTypePage[Number(this.activeWorkTypeTab)] || 1)
                : this.queryData.current;
            const size = this.queryData.size;
            const start = (current - 1) * size;
            return {
                total: total,
                current: current,
                records: this.filteredJobList.slice(start, start + size),
            };
        },
        isRegisterDisabled() {
            return !this.isEntranceOpen || this.isBm === 1;
        },
        isSupplementSubmitDisabled() {
            return this.supplementMode && !this.isEntranceOpen;
        },
    },
    watch: {
        querySearch() {
            this.queryData.current = 1;
            this.resetWorkTypePagination();
        },
        normalizedTalentType(val) {
            if (val === 2) {
                this.resetWorkTypePagination();
            }
            if (val != null && val !== '') {
                this.bmObj.entrance_type = val;
                this.ensureHighestEducationValid();
                this.loadApplicationStats();
            }
            this.evaluateEntranceOpenAccess();
        },
        selectedMajorCategory() {
            if (this.normalizedTalentType === 0) {
                this.loadApplicationStats();
            }
        },
        selectedMajorName() {
            if (this.normalizedTalentType === 1) {
                this.loadApplicationStats();
            }
        },
        'bmObj.highestEducation'() {
            this.initEducationRecords();
        },
        dialogVisible(val) {
            if (val) {
                this.loadXuexinOcrConfig();
            }
        },
        supplementData: {
            deep: true,
            handler(val) {
                if (this.supplementMode && val && val.id) {
                    this.hydrateFromSupplementData(val);
                }
            },
        },
    },
    methods: {
        buildOptionsSortedByMinId(valueGetter) {
            const minIdByValue = new Map();
            this.allJobList.forEach((item) => {
                const value = valueGetter(item);
                if (!value) {
                    return;
                }
                const id = Number(item.id);
                if (Number.isNaN(id)) {
                    return;
                }
                const existing = minIdByValue.get(value);
                if (existing === undefined || id < existing) {
                    minIdByValue.set(value, id);
                }
            });
            return Array.from(minIdByValue.entries())
                .sort((a, b) => a[1] - b[1])
                .map(([value]) => value);
        },
        fileNameFromUrl(url) {
            if (!url) {
                return '';
            }
            const path = String(url).split('?')[0];
            const parts = path.split('/');
            return parts[parts.length - 1] || 'file';
        },
        toUploadFileObj(url) {
            if (!url) {
                return null;
            }
            return {
                url,
                fileName: this.fileNameFromUrl(url),
            };
        },
        parseInstitutionFields(institutionType) {
            const raw = String(institutionType || '').trim();
            const qsMatch = raw.match(/^QS(\d+)$/i);
            if (qsMatch) {
                return { isDomestic: 0, institutionType: '', qsRanking: Number(qsMatch[1]) };
            }
            return { isDomestic: 1, institutionType: raw, qsRanking: undefined };
        },
        hydrateFromSupplementData(data) {
            if (!data || !data.id) {
                return;
            }
            const d = data;
            this.supplementApplicationId = d.id;
            const entrance = d.entrance_type != null ? d.entrance_type : d.entranceType;
            if (entrance != null && entrance !== '') {
                this.talentType = Number(entrance);
                this.bmObj.entrance_type = Number(entrance);
            }
            this.evaluateEntranceOpenAccess();
            this.bmObj.name = d.name || '';
            this.bmObj.gender = d.gender != null ? Number(d.gender) : 1;
            this.genderManuallySet = true;
            this.bmObj.phone = d.phone || this.bmObj.phone || '';
            this.bmObj.email = d.email || '';
            const rawPolitical = d.political_status != null ? d.political_status : d.politicalStatus;
            this.bmObj.politicalStatus = (rawPolitical != null && rawPolitical !== '') ? rawPolitical : null;
            this.bmObj.idCardNumber = d.id_card_number || d.idCardNumber || '';
            this.bmObj.nativePlace = d.native_place || d.nativePlace || '';
            this.bmObj.address = d.address || '';
            this.bmObj.residentProvinceCity = d.resident_province_city || d.residentProvinceCity || '';
            this.bmObj.residentCity = d.resident_city || d.residentCity || '';
            this.bmObj.highestEducation = d.highest_education || d.highestEducation || d.education || '';
            this.bmObj.graduatedInstitution = d.graduated_institution || d.graduatedInstitution || '';
            this.bmObj.major = d.major || '';
            this.bmObj.education = d.education || '';
            this.bmObj.institutionType = d.institution_type || d.institutionType || '';
            this.bmObj.graduationTime = d.graduation_time || d.graduationTime || '';
            this.bmObj.photoUrl = d.photo_url || d.photoUrl || '';
            this.bmObj.positionsName = d.positions_name || d.positionsName || '';
            this.bmObj.workType = d.work_type != null ? d.work_type : d.workType;
            this.bmObj.majorCategory = d.major_category || d.majorCategory || '';
            const positionId = d.position_id != null ? d.position_id : d.positionId;
            if (positionId != null) {
                this.bmObj.positionId = positionId;
                this.bmObj.recruitPositionInfoId = positionId;
                this.loadRecruitPositionForSupplement(positionId);
            }
            if (this.bmObj.residentProvinceCity) {
                this.handleProvinceChange(this.bmObj.residentProvinceCity);
            }
            this.syncNativePlaceFromDropdown();
            this.ensureHighestEducationValid();

            const familyList = d.family || d.familyMemberList || [];
            if (familyList.length) {
                this.family = familyList.map((item) => ({
                    relationType: item.relationType != null ? item.relationType : item.relation_type,
                    name: item.name || '',
                    mobile: item.mobile || '',
                    workUnit: item.workUnit || item.work_unit || '',
                    position: item.position || '',
                    birthDate: item.birthDate || item.birth_date || '',
                    isInLuan: item.isInLuan != null ? item.isInLuan : (item.is_in_luan != null ? item.is_in_luan : 0),
                }));
            }

            this.files = { f1: null, f2: null, f3: null, f4: null, f5: null, f6: null, f7: null, f9: null };
            const attachments = d.file || d.jobApplicationAttachmentList || [];
            const segmentFiles = {};
            attachments.forEach((item) => {
                const type = item.attachment_type != null ? item.attachment_type : item.attachmentType;
                const url = item.file_url || item.fileUrl;
                if (!url) {
                    return;
                }
                const fileObj = this.toUploadFileObj(url);
                const seg = item.education_segment_order != null
                    ? item.education_segment_order
                    : item.educationSegmentOrder;
                if (type === 1) {
                    this.files.f1 = fileObj;
                } else if (type === 2) {
                    this.files.f2 = fileObj;
                } else if (type === 3) {
                    this.files.f3 = fileObj;
                } else if (type === 4) {
                    this.files.f4 = fileObj;
                } else if (type === 9) {
                    this.files.f9 = fileObj;
                } else if (seg != null) {
                    const key = seg + '_' + type;
                    segmentFiles[key] = fileObj;
                } else if (type === 5) {
                    this.files.f5 = fileObj;
                } else if (type === 6) {
                    this.files.f6 = fileObj;
                } else if (type === 7) {
                    this.files.f7 = fileObj;
                }
            });

            const eduHistory = d.educationHistory || d.education_history || [];
            if (eduHistory.length) {
                this.educationRecords = eduHistory.map((edu, index) => {
                    const institutionType = edu.institution_type || edu.institutionType || '';
                    const parsed = this.parseInstitutionFields(institutionType);
                    const isDomesticRaw = edu.is_domestic != null ? edu.is_domestic : edu.isDomestic;
                    let isDomestic = this.parseIsDomestic(isDomesticRaw);
                    if (isDomestic == null) {
                        isDomestic = this.parseIsDomestic(parsed.isDomestic);
                    }
                    const record = this.createEmptyEducationRecord(edu.segment_label || edu.segmentLabel || ('学历段' + (index + 1)));
                    record.graduatedInstitution = edu.graduated_institution || edu.graduatedInstitution || '';
                    record.major = edu.major || '';
                    record.majorCode = edu.major_code || edu.majorCode || '';
                    record.education = edu.education_level || edu.educationLevel || '';
                    record.departureDate = normalizeGraduationYearForPicker(edu.departure_date || edu.departureDate || '');
                    record.isDomestic = isDomestic;
                    if (isDomestic === 0) {
                        record.qsRanking = edu.qs_ranking != null ? edu.qs_ranking : (edu.qsRanking != null ? edu.qsRanking : parsed.qsRanking);
                        record.institutionType = '';
                    } else {
                        record.institutionType = parsed.institutionType || institutionType;
                        record.qsRanking = undefined;
                    }
                    record.file = segmentFiles[(edu.segment_order != null ? edu.segment_order : (edu.segmentOrder != null ? edu.segmentOrder : index)) + '_7'] || null;
                    record.graduationCert = segmentFiles[(edu.segment_order != null ? edu.segment_order : (edu.segmentOrder != null ? edu.segmentOrder : index)) + '_5'] || null;
                    record.degreeCert = segmentFiles[(edu.segment_order != null ? edu.segment_order : (edu.segmentOrder != null ? edu.segmentOrder : index)) + '_6'] || null;
                    record.studyAbroadCert = segmentFiles[(edu.segment_order != null ? edu.segment_order : (edu.segmentOrder != null ? edu.segmentOrder : index)) + '_10'] || null;
                    if (!record.file && index === eduHistory.length - 1) {
                        record.file = this.files.f7;
                    }
                    return record;
                });
                this.ensureEduDomesticDefaults();
            } else if (this.bmObj.highestEducation) {
                this.initEducationRecords();
            }
        },
        loadRecruitPositionForSupplement(positionId) {
            if (!positionId || !Cookies.get('reqToKen')) {
                return;
            }
            axios.get('/zhaopinapi/recruit-position-info/' + positionId, {
                headers: { Authorization: Cookies.get('reqToKen') },
            }).then((res) => {
                const result = res.data;
                if (result && result.success && result.data) {
                    this.allJobList = [result.data];
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        markGenderTouched() {
            this.genderManuallySet = true;
        },
        normalizeGenderValue(raw) {
            const n = Number(raw);
            if (n === 0 || n === 1 || n === 2) {
                return n;
            }
            return null;
        },
        buildSubmissionPayload() {
            this.syncNativePlaceFromDropdown();
            this.syncEducationToBmObj();
            const gender = this.normalizeGenderValue(this.bmObj.gender);
            if (gender != null) {
                this.bmObj.gender = gender;
            }
            this.bmObj.userId = this.userInfo.id || this.bmObj.userId;
            if (this.userInfo.phone) {
                this.bmObj.phone = this.userInfo.phone;
            }
            this.bmObj.fillMethod = 0;
            this.bmObj.educationHistoryList = this.buildEducationHistoryList();
            this.bmObj.workExperienceList = [];
            this.bmObj.familyMemberList = [];
            this.bmObj.jobApplicationAttachmentList = [];
            for (let j = 0; j < this.family.length; j++) {
                const _family = {
                    relationType: this.family[j].relationType,
                    name: this.family[j].name,
                    mobile: this.family[j].mobile,
                    workUnit: this.family[j].workUnit,
                    position: this.family[j].position || '',
                    isInLuan: this.family[j].isInLuan,
                };
                if (this.family[j].birthDate) {
                    _family.birthDate = moment(this.family[j].birthDate).format('YYYY-MM-DD');
                }
                this.bmObj.familyMemberList.push(_family);
            }
            if (this.files.f1) {
                this.bmObj.jobApplicationAttachmentList.push({ attachmentType: 1, fileUrl: this.files.f1.url });
            }
            if (this.files.f2) {
                this.bmObj.jobApplicationAttachmentList.push({ attachmentType: 2, fileUrl: this.files.f2.url });
            }
            if (this.files.f3) {
                this.bmObj.jobApplicationAttachmentList.push({ attachmentType: 3, fileUrl: this.files.f3.url });
                this.bmObj.photoUrl = this.files.f3.url;
            }
            if (this.files.f4) {
                this.bmObj.jobApplicationAttachmentList.push({ attachmentType: 4, fileUrl: this.files.f4.url });
            }
            if (this.educationRecords.length > 0) {
                for (let i = 0; i < this.educationRecords.length; i++) {
                    const edu = this.educationRecords[i];
                    if (this.isDomesticInstitution(edu)) {
                        if (edu.graduationCert && edu.graduationCert.url) {
                            this.bmObj.jobApplicationAttachmentList.push({ attachmentType: 5, fileUrl: edu.graduationCert.url, educationSegmentOrder: i });
                        }
                        if (edu.degreeCert && edu.degreeCert.url) {
                            this.bmObj.jobApplicationAttachmentList.push({ attachmentType: 6, fileUrl: edu.degreeCert.url, educationSegmentOrder: i });
                        }
                        const eduFile = edu.file;
                        if (eduFile && eduFile.url) {
                            this.bmObj.jobApplicationAttachmentList.push({ attachmentType: 7, fileUrl: eduFile.url, educationSegmentOrder: i });
                        }
                    } else if (this.isOverseasInstitution(edu)) {
                        if (edu.studyAbroadCert && edu.studyAbroadCert.url) {
                            this.bmObj.jobApplicationAttachmentList.push({ attachmentType: 10, fileUrl: edu.studyAbroadCert.url, educationSegmentOrder: i });
                        }
                    }
                }
            } else {
                if (this.files.f5) {
                    this.bmObj.jobApplicationAttachmentList.push({ attachmentType: 5, fileUrl: this.files.f5.url });
                }
                if (this.files.f6) {
                    this.bmObj.jobApplicationAttachmentList.push({ attachmentType: 6, fileUrl: this.files.f6.url });
                }
            }
            if (this.educationRecords.length === 0 && this.files.f7) {
                this.bmObj.jobApplicationAttachmentList.push({ attachmentType: 7, fileUrl: this.files.f7.url });
            }
            if (this.files.f9 && this.files.f9.url) {
                this.bmObj.jobApplicationAttachmentList.push({ attachmentType: 9, fileUrl: this.files.f9.url });
            }
            return this.bmObj;
        },
        resubmitSupplement() {
            if (this.submitting) {
                return;
            }
            if (!this.supplementApplicationId) {
                this.$message.error('报名信息未就绪');
                return;
            }
            this.submitting = true;
            const payload = this.buildSubmissionPayload();
            axios.put('/zhaopinapi/job-applications/' + this.supplementApplicationId + '/resubmit-supplement', payload, {
                headers: { Authorization: Cookies.get('reqToKen') },
            }).then((res) => {
                const _d = res.data;
                if (_d.success) {
                    this.$message.success('补充资料已提交，已进入资格审查');
                    this.$emit('supplement-submitted');
                } else {
                    this.$alert(_d.message || '提交失败', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                    });
                }
            }).catch((error) => {
                const msg = (error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : '提交失败，请稍后重试';
                this.$alert(msg, '提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                });
                console.log(error);
            }).finally(() => {
                this.submitting = false;
            });
        },
        hasMeaningfulPrefillValue(val) {
            return this.sanitizeOcrText(val) !== '';
        },
        /** 学信网 OCR 占位专业名：仅此值允许用户修改学科/专业 */
        isOcrMajorEditablePlaceholder(major) {
            const text = this.sanitizeOcrText(major);
            return text === '系所全日制学位硕士' || text === '系所硕士项目中心';
        },
        shouldLockMajorFromOcrValue(major) {
            return this.hasMeaningfulPrefillValue(major) && !this.isOcrMajorEditablePlaceholder(major);
        },
        shouldLockEduFieldFromOcr(fieldKey, val) {
            if (fieldKey === 'major') {
                return this.shouldLockMajorFromOcrValue(val);
            }
            return this.hasMeaningfulPrefillValue(val);
        },
        syncReadonlyLock(fieldKey, val) {
            this.prefilledReadonly[fieldKey] = this.shouldLockEduFieldFromOcr(fieldKey, val);
        },
        getHighestEducationOptionsByEntrance(entranceType) {
            const allOptions = [
                {label: '专科', value: '专科'},
                {label: '本科', value: '本科'},
                {label: '硕士研究生', value: '硕士研究生'},
                {label: '博士研究生', value: '博士研究生'},
            ];
            const type = entranceType == null ? '' : Number(entranceType);
            if (type === 0) {
                return allOptions.filter((item) => item.value === '硕士研究生' || item.value === '博士研究生');
            }
            if (type === 1) {
                return allOptions.filter((item) => item.value !== '专科' && item.value !== '博士研究生');
            }
            if (type === 2) {
                return allOptions.filter((item) => item.value !== '博士研究生');
            }
            return allOptions.slice();
        },
        ensureHighestEducationValid() {
            const allowed = this.highestEducationList.map((item) => item.value);
            if (this.bmObj.highestEducation && allowed.indexOf(this.bmObj.highestEducation) === -1) {
                this.bmObj.highestEducation = '';
                this.educationRecords = [];
            }
        },
        getEducationSectionCount(highestEducation) {
            const map = {
                '专科': 1,
                '本科': 1,
                '硕士研究生': 2,
                '博士研究生': 3,
            };
            return map[highestEducation] || 0;
        },
        getEducationSectionLabels(highestEducation) {
            if (this.resolvedEntranceType === 2) {
                const singleMap = {
                    '专科': ['专科信息'],
                    '本科': ['本科信息'],
                    '硕士研究生': ['研究生信息'],
                    '博士研究生': ['博士信息'],
                };
                return singleMap[highestEducation] || [];
            }
            const count = this.getEducationSectionCount(highestEducation);
            if (count === 3) {
                return ['本科信息', '研究生信息', '博士信息'];
            }
            if (count === 2) {
                return ['本科信息', '研究生信息'];
            }
            if (count === 1) {
                return highestEducation === '专科' ? ['专科信息'] : ['本科信息'];
            }
            return [];
        },
        isTechUndergradEduSection(edu) {
            return this.needsTechUndergradMajorCode && edu && edu.label === '本科信息';
        },
        isHighestEducationSegment(edu) {
            const highestLabel = this.getHighestEducationSegmentLabel(this.bmObj.highestEducation);
            return !!(edu && highestLabel && edu.label === highestLabel);
        },
        shouldShowDomesticField(edu) {
            if (this.resolvedEntranceType === 1 && this.bmObj.highestEducation === '本科' && edu && edu.label === '本科信息') {
                return false;
            }
            return true;
        },
        shouldShowQsRankingField(edu) {
            return this.isOverseasInstitution(edu);
        },
        /** 海外院校：各学历段 QS 均必填 */
        requiresQsRankingValidation(edu) {
            return this.isOverseasInstitution(edu);
        },
        /** 优培：仅最高为硕士研究生时校验研究生段 QS≤100；博士研究生均不校验≤100 */
        requiresQsTop100Validation(edu) {
            if (!this.isOverseasInstitution(edu) || this.normalizedTalentType === 2) {
                return false;
            }
            if (this.resolvedEntranceType !== 0) {
                return true;
            }
            const highest = this.bmObj.highestEducation;
            if (highest === '博士研究生') {
                return false;
            }
            if (highest === '硕士研究生') {
                return !!(edu && edu.label === '研究生信息');
            }
            return this.isHighestEducationSegment(edu);
        },
        getDomesticFieldLabel(edu) {
            const map = {
                '专科信息': '专科',
                '本科信息': '本科',
                '研究生信息': '研究生',
                '博士信息': '博士',
            };
            const prefix = map[edu.label] || String(edu.label || '').replace(/信息$/, '');
            return prefix + '是否为国内院校';
        },
        parseIsDomestic(value) {
            if (value === 0 || value === 1) {
                return value;
            }
            if (value === '0') {
                return 0;
            }
            if (value === '1') {
                return 1;
            }
            return null;
        },
        isDomesticInstitution(edu) {
            return edu && this.parseIsDomestic(edu.isDomestic) === 1;
        },
        isOverseasInstitution(edu) {
            return edu && this.parseIsDomestic(edu.isDomestic) === 0;
        },
        shouldShowXuexinUpload(eduIndex) {
            const edu = this.educationRecords[eduIndex];
            return this.isDomesticInstitution(edu);
        },
        shouldShowGradDegreeCerts(edu) {
            return this.isDomesticInstitution(edu);
        },
        isXuexinReportRequired(edu) {
            return this.isDomesticInstitution(edu);
        },
        isGradDegreeCertRequired(edu) {
            if (!this.isDomesticInstitution(edu) || edu.label === '博士信息') {
                return false;
            }
            if (!edu.departureDate) {
                return true;
            }
            const year = moment(edu.departureDate).year();
            return year !== new Date().getFullYear();
        },
        ensureEduDomesticDefaults() {
            (this.educationRecords || []).forEach((edu) => {
                if (!this.shouldShowDomesticField(edu)) {
                    edu.isDomestic = 1;
                }
            });
        },
        findSelectedRecruitPosition() {
            const id = this.bmObj.recruitPositionInfoId || this.bmObj.positionId;
            if (id == null || id === '') {
                return null;
            }
            return this.allJobList.find((item) => String(item.id) === String(id)) || null;
        },
        validateTechUndergradMajorMatch() {
            if (!this.needsTechUndergradMajorCode) {
                return true;
            }
            const position = this.findSelectedRecruitPosition();
            if (!position) {
                this.$message.error('请先选择报名岗位');
                return false;
            }
            const edu = this.educationRecords.find((e) => e.label === '本科信息')
                || (this.educationRecords.length ? this.educationRecords[0] : null);
            if (!edu) {
                return true;
            }
            const reqName = String(position.undergraduateMajorName || position.undergraduate_major_name || '').trim();
            const reqCode = String(position.undergraduateMajorCode || position.undergraduate_major_code || '').trim();
            const actualName = String(edu.major || '').trim();
            const actualCode = String(edu.majorCode || '').trim();
            const msgs = [];
            if (reqName && actualName !== reqName) {
                msgs.push('不符合专业要求，本岗位专业要求为：' + reqName);
            }
            if (reqCode && actualCode !== reqCode) {
                msgs.push('不符合专业代码要求，本岗位专业代码要求为：' + reqCode);
            }
            if (msgs.length) {
                this.$alert(msgs.join('\n'), '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                });
                return false;
            }
            return true;
        },
        getHighestEducationSegmentLabel(highestEducation) {
            const map = {
                '专科': '专科信息',
                '本科': '本科信息',
                '硕士研究生': '研究生信息',
                '博士研究生': '博士信息',
            };
            return map[highestEducation] || '';
        },
        getHighestEducationDepartureRecord() {
            const label = this.getHighestEducationSegmentLabel(this.bmObj.highestEducation);
            if (!label) {
                return null;
            }
            return this.educationRecords.find((e) => e.label === label)
                || (this.educationRecords.length ? this.educationRecords[this.educationRecords.length - 1] : null);
        },
        parseGraduationYearsRequirement(req) {
            if (!req || !String(req).trim()) {
                return [];
            }
            return String(req).split(/[、,，/|\s]+/)
                .map((item) => item.trim())
                .filter(Boolean)
                .map((item) => {
                    const matched = item.match(/\d{4}/);
                    return matched ? matched[0] : item;
                });
        },
        validateGraduationYearsRequirement() {
            return this.validateGraduationYearsRequirementAsync();
        },
        async validateGraduationYearsRequirementAsync() {
            if (this.bmObj.highestEducation === '博士研究生') {
                return true;
            }
            const position = this.findSelectedRecruitPosition();
            if (!position) {
                return true;
            }
            const reqRaw = String(position.graduationYearsRequirement || position.graduation_years_requirement || '').trim();
            if (!reqRaw) {
                return true;
            }
            const allowedYears = this.parseGraduationYearsRequirement(reqRaw);
            if (!allowedYears.length) {
                return true;
            }
            const edu = this.getHighestEducationDepartureRecord();
            if (!edu || !edu.departureDate) {
                return true;
            }
            const year = moment(edu.departureDate).format('YYYY');
            if (allowedYears.indexOf(year) === -1) {
                const whitelisted = await this.checkGraduationYearsWhitelist();
                if (whitelisted) {
                    return true;
                }
                this.$alert('毕业年限不符合要求，本岗位毕业年限要求为：' + reqRaw, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                });
                return false;
            }
            return true;
        },
        async checkGraduationYearsWhitelist() {
            const name = String(this.bmObj.name || '').trim();
            if (!name || !Cookies.get('reqToKen')) {
                return false;
            }
            try {
                const res = await axios.get('/zhaopinapi/graduation-years-whitelist/match', {
                    params: { name: name },
                    headers: { Authorization: Cookies.get('reqToKen') },
                });
                const _d = res.data;
                return !!(_d && _d.success && _d.data === true);
            } catch (error) {
                console.log(error);
                return false;
            }
        },
        eduLabelToSegmentType(label) {
            const map = {
                '专科信息': '专科',
                '本科信息': '本科',
                '研究生信息': '研究生',
                '博士信息': '博士',
            };
            return map[label] || '';
        },
        buildXuexinOcrConfigKey(entranceType, highestEducation, segmentType) {
            return `${entranceType}_${highestEducation}_${segmentType}`;
        },
        loadXuexinOcrConfig() {
            if (!Cookies.get('reqToKen')) {
                return;
            }
            axios.get('/zhaopinapi/xuexin-ocr-config/find-all', {
                headers: { Authorization: Cookies.get('reqToKen') },
            }).then((res) => {
                const d = res.data;
                if (d && (d.success === true || d.code === 200) && Array.isArray(d.data)) {
                    const map = {};
                    d.data.forEach((row) => {
                        const key = this.buildXuexinOcrConfigKey(
                            row.entranceType,
                            row.highestEducation,
                            row.segmentType
                        );
                        map[key] = row.ocrEnabled === 1 ? 1 : 0;
                    });
                    this.xuexinOcrConfigMap = map;
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        isXuexinOcrEnabled(eduIndex) {
            const edu = this.educationRecords[eduIndex];
            if (!edu || this.isOverseasInstitution(edu)) {
                return false;
            }
            const entranceType = this.resolvedEntranceType;
            const highestEducation = this.bmObj.highestEducation;
            if (!edu || entranceType == null || !highestEducation) {
                return true;
            }
            const segmentType = edu.segmentType || this.eduLabelToSegmentType(edu.label);
            if (!segmentType) {
                return true;
            }
            const key = this.buildXuexinOcrConfigKey(entranceType, highestEducation, segmentType);
            if (this.xuexinOcrConfigMap[key] === undefined) {
                return true;
            }
            return this.xuexinOcrConfigMap[key] === 1;
        },
        getXuexinUploadTitle(eduIndex) {
            if (this.isXuexinOcrEnabled(eduIndex)) {
                return '学信网学籍验证报告 拖拽至此区域自动解析OCR';
            }
            return '学信网学籍验证报告（仅上传附件，请手动填写下方信息）';
        },
        getXuexinUploadHint(eduIndex) {
            if (this.isXuexinOcrEnabled(eduIndex)) {
                return '将文件大小控制在 6M 以内，支持格式 pdf，上传成功后，系统将自动解析并填充，便于后续填写、修改。';
            }
            return '将文件大小控制在 6M 以内，支持格式 pdf。当前未开启 OCR 识别，上传后请手动填写学历信息。';
        },
        createEmptyEducationRecord(label) {
            return {
                label,
                segmentType: this.eduLabelToSegmentType(label),
                graduatedInstitution: '',
                major: '',
                majorCode: '',
                education: '',
                departureDate: '',
                isDomestic: null,
                institutionType: '',
                qsRanking: undefined,
                file: null,
                graduationCert: null,
                degreeCert: null,
                studyAbroadCert: null,
                prefilledReadonly: {
                    graduatedInstitution: false,
                    major: false,
                    education: false,
                    departureDate: false,
                },
            };
        },
        initEducationRecords() {
            const labels = this.getEducationSectionLabels(this.bmObj.highestEducation);
            const prev = this.educationRecords || [];
            this.educationRecords = labels.map((label, index) => {
                if (prev[index]) {
                    return Object.assign({}, prev[index], {
                        label,
                        segmentType: this.eduLabelToSegmentType(label),
                    });
                }
                const record = this.createEmptyEducationRecord(label);
                if (index === labels.length - 1) {
                    record.graduatedInstitution = this.bmObj.graduatedInstitution || '';
                    record.major = this.bmObj.major || '';
                    record.education = this.bmObj.education || '';
                    record.departureDate = normalizeGraduationYearForPicker(this.bmObj.graduationTime || '');
                    record.institutionType = this.bmObj.institutionType || '';
                    record.file = this.files.f7 || null;
                    record.prefilledReadonly.graduatedInstitution = this.hasMeaningfulPrefillValue(record.graduatedInstitution);
                    record.prefilledReadonly.major = this.shouldLockMajorFromOcrValue(record.major);
                    record.prefilledReadonly.education = this.hasMeaningfulPrefillValue(record.education);
                    record.prefilledReadonly.departureDate = this.hasMeaningfulPrefillValue(record.departureDate);
                }
                return record;
            });
            this.ensureEduDomesticDefaults();
        },
        onEduDomesticChange(edu) {
            if (this.isDomesticInstitution(edu)) {
                edu.qsRanking = undefined;
                edu.studyAbroadCert = null;
            } else if (this.isOverseasInstitution(edu)) {
                edu.institutionType = '';
                edu.file = null;
                edu.graduationCert = null;
                edu.degreeCert = null;
                if (edu.prefilledReadonly) {
                    edu.prefilledReadonly.graduatedInstitution = false;
                    edu.prefilledReadonly.major = false;
                    edu.prefilledReadonly.education = false;
                    edu.prefilledReadonly.departureDate = false;
                }
            }
        },
        syncEduReadonlyLock(eduIndex, fieldKey, val) {
            const edu = this.educationRecords[eduIndex];
            if (edu && edu.prefilledReadonly) {
                this.$set(edu.prefilledReadonly, fieldKey, this.shouldLockEduFieldFromOcr(fieldKey, val));
            }
        },
        syncEducationToBmObj() {
            if (!this.educationRecords.length) {
                return;
            }
            const highestEdu = this.getHighestEducationDepartureRecord()
                || this.educationRecords[this.educationRecords.length - 1];
            this.bmObj.graduatedInstitution = highestEdu.graduatedInstitution;
            this.bmObj.major = highestEdu.major;
            this.bmObj.education = highestEdu.education;
            this.bmObj.graduationTime = toGraduationYearStorage(highestEdu.departureDate) || '';
            if (this.isDomesticInstitution(highestEdu)) {
                this.bmObj.institutionType = highestEdu.institutionType;
            } else if (this.isOverseasInstitution(highestEdu) && highestEdu.qsRanking != null && highestEdu.qsRanking !== '') {
                this.bmObj.institutionType = 'QS' + highestEdu.qsRanking;
            } else {
                this.bmObj.institutionType = '';
            }
            const lastFile = highestEdu.file;
            this.files.f7 = lastFile || null;
        },
        validateEducationRecords() {
            if (!this.bmObj.highestEducation) {
                this.$message.error('请选择最高学历！');
                return false;
            }
            for (let i = 0; i < this.educationRecords.length; i++) {
                const edu = this.educationRecords[i];
                const prefix = edu.label + '：';
                if (!edu.graduatedInstitution) {
                    this.$message.error(prefix + '学校不能为空！');
                    return false;
                }
                if (!edu.major) {
                    this.$message.error(prefix + '学科/专业不能为空！');
                    return false;
                }
                if (this.isTechUndergradEduSection(edu) && !String(edu.majorCode || '').trim()) {
                    this.$message.error(prefix + '专业代码不能为空！');
                    return false;
                }
                if (!edu.education) {
                    this.$message.error(prefix + '学历不能为空！');
                    return false;
                }
                if (!edu.departureDate) {
                    this.$message.error(prefix + '毕业日期不能为空！');
                    return false;
                }
                if (this.shouldShowDomesticField(edu)) {
                    if (this.parseIsDomestic(edu.isDomestic) == null) {
                        this.$message.error(prefix + '请选择' + this.getDomesticFieldLabel(edu) + '！');
                        return false;
                    }
                } else {
                    edu.isDomestic = 1;
                }
                if (this.shouldShowDomesticField(edu) && this.isDomesticInstitution(edu) && !edu.institutionType) {
                    this.$message.error(prefix + '请选择院校层级！');
                    return false;
                }
                if (this.requiresQsRankingValidation(edu) && (edu.qsRanking == null || edu.qsRanking === '')) {
                    this.$message.error(prefix + '请填写院校2025QS排名！');
                    return false;
                }
                if (this.requiresQsRankingValidation(edu)) {
                    const qs = Number(edu.qsRanking);
                    if (isNaN(qs) || qs < 1) {
                        this.$message.error(prefix + '请填写有效的院校2025QS排名！');
                        return false;
                    }
                    if (this.requiresQsTop100Validation(edu) && qs > 100) {
                        this.$message.error('「' + edu.label + '」院校排名不符合报名要求');
                        return false;
                    }
                }
                if (this.isXuexinReportRequired(edu) && (!edu.file || !edu.file.url)) {
                    this.$message.error(prefix + '请上传学信网学籍验证报告！');
                    return false;
                }
                if (this.isGradDegreeCertRequired(edu)) {
                    if (!edu.graduationCert || !edu.graduationCert.url) {
                        this.$message.error(prefix + '请上传毕业证！');
                        return false;
                    }
                    if (!edu.degreeCert || !edu.degreeCert.url) {
                        this.$message.error(prefix + '请上传学位证！');
                        return false;
                    }
                }
                if (this.requiresQsRankingValidation(edu) && (!edu.studyAbroadCert || !edu.studyAbroadCert.url)) {
                    this.$message.error(prefix + '请上传教育部留学服务中心认证！');
                    return false;
                }
            }
            return true;
        },
        async validateBmForm() {
            if (!this.validateEducationRecords()) {
                return false;
            }
            if (!this.validateTechUndergradMajorMatch()) {
                return false;
            }
            if (!(await this.validateGraduationYearsRequirementAsync())) {
                return false;
            }
            if (!this.files.f1 || !this.files.f1.url) {
                this.$message.error('请上传身份证人像面！');
                return false;
            }
            if (!this.files.f2 || !this.files.f2.url) {
                this.$message.error('请上传身份证国徽面！');
                return false;
            }
            if (!this.files.f3 || !this.files.f3.url) {
                this.$message.error('请上传免冠照！');
                return false;
            }
            if (!this.bmObj.name) {
                this.$message.error('姓名不能为空！');
                return false;
            }
            if (this.bmObj.gender !== 0 && this.bmObj.gender !== 1 && this.bmObj.gender !== 2) {
                this.$message.error('请选择性别！');
                return false;
            }
            if (!this.bmObj.birthDate) {
                this.$message.error('出生日期不能为空！');
                return false;
            }
            if (!this.bmObj.idCardNumber) {
                this.$message.error('身份证号不能为空！');
                return false;
            }
            if (this.bmObj.politicalStatus === null || this.bmObj.politicalStatus === undefined || this.bmObj.politicalStatus === '') {
                this.$message.error('请选择政治面貌！');
                return false;
            }
            if (!this.bmObj.residentProvinceCity) {
                this.$message.error('请选择籍贯省份！');
                return false;
            }
            if (!this.bmObj.residentCity) {
                this.$message.error('请选择籍贯城市！');
                return false;
            }
            if (!this.bmObj.address || !String(this.bmObj.address).trim()) {
                this.$message.error('常住地址不能为空！');
                return false;
            }
            if (!this.bmObj.phone) {
                this.$message.error('手机号码不能为空！');
                return false;
            }
            if (!this.bmObj.email) {
                this.$message.error('邮箱不能为空！');
                return false;
            }
            for (let j = 0; j < this.family.length; j++) {
                const member = this.family[j];
                const relationLabel = this.relationType[member.relationType] || '家庭成员';
                if (!member.name) {
                    this.$message.error(relationLabel + '姓名不能为空！');
                    return false;
                }
                if (!member.mobile) {
                    this.$message.error(relationLabel + '手机号不能为空！');
                    return false;
                }
                if (!member.workUnit) {
                    this.$message.error(relationLabel + '工作单位不能为空！');
                    return false;
                }
            }
            if (!this.files.f9 || !this.files.f9.url) {
                this.$message.error('请上传3个月内开具的无犯罪记录证明！');
                return false;
            }
            if (this.bmObj.isCommitted !== 1) {
                this.$message.error('请勾选本人承诺！');
                return false;
            }
            return true;
        },
        isAllowedPdfOrImage(file) {
            if (!file) {
                return false;
            }
            const fileName = file.name || '';
            const ext = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
            const imageExts = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp'];
            if (ext === 'pdf' || imageExts.indexOf(ext) !== -1) {
                return true;
            }
            const mime = (file.type || '').toLowerCase();
            return mime === 'application/pdf' || mime.indexOf('image/') === 0;
        },
        uploadEduCertIfValid(file, type, eduIndex) {
            if (!this.isAllowedPdfOrImage(file)) {
                this.$message.error('仅支持 PDF 或图片格式！');
                return;
            }
            this.uploadFile(file, type, eduIndex);
        },
        upEduGradCert(event, eduIndex) {
            const _f = event.target.files[0];
            if (_f) {
                this.uploadEduCertIfValid(_f, 5, eduIndex);
            }
            event.target.value = null;
        },
        upEduGradCertTz(event, eduIndex) {
            const droppedFiles = event.dataTransfer.files;
            if (droppedFiles.length > 1) {
                this.$message.error('毕业证只允许上传一个文件！');
            } else if (droppedFiles[0]) {
                this.uploadEduCertIfValid(droppedFiles[0], 5, eduIndex);
            }
            event.dataTransfer.value = '';
        },
        upEduDegCert(event, eduIndex) {
            const _f = event.target.files[0];
            if (_f) {
                this.uploadEduCertIfValid(_f, 6, eduIndex);
            }
            event.target.value = null;
        },
        upEduDegCertTz(event, eduIndex) {
            const droppedFiles = event.dataTransfer.files;
            if (droppedFiles.length > 1) {
                this.$message.error('学位证只允许上传一个文件！');
            } else if (droppedFiles[0]) {
                this.uploadEduCertIfValid(droppedFiles[0], 6, eduIndex);
            }
            event.dataTransfer.value = '';
        },
        delEduGradCert(eduIndex) {
            if (this.educationRecords[eduIndex]) {
                this.$set(this.educationRecords[eduIndex], 'graduationCert', null);
            }
        },
        delEduDegCert(eduIndex) {
            if (this.educationRecords[eduIndex]) {
                this.$set(this.educationRecords[eduIndex], 'degreeCert', null);
            }
        },
        upEduStudyAbroadCert(event, eduIndex) {
            const _f = event.target.files[0];
            if (_f) {
                this.uploadEduCertIfValid(_f, 10, eduIndex);
            }
            event.target.value = null;
        },
        upEduStudyAbroadCertTz(event, eduIndex) {
            const droppedFiles = event.dataTransfer.files;
            if (droppedFiles.length > 1) {
                this.$message.error('教育部留学服务中心认证只允许上传一个文件！');
            } else if (droppedFiles[0]) {
                this.uploadEduCertIfValid(droppedFiles[0], 10, eduIndex);
            }
            event.dataTransfer.value = '';
        },
        delEduStudyAbroadCert(eduIndex) {
            if (this.educationRecords[eduIndex]) {
                this.$set(this.educationRecords[eduIndex], 'studyAbroadCert', null);
            }
        },
        upCriminalRecord(event) {
            const _f = event.target.files[0];
            if (_f) {
                if (!this.isAllowedPdfOrImage(_f)) {
                    this.$message.error('仅支持 PDF 或图片格式！');
                    event.target.value = null;
                    return;
                }
                this.uploadFile(_f, 9);
            }
            event.target.value = null;
        },
        upCriminalRecordTz(event) {
            const droppedFiles = event.dataTransfer.files;
            if (droppedFiles.length > 1) {
                this.$message.error('无犯罪记录证明只允许上传一个文件！');
            } else if (droppedFiles[0]) {
                if (!this.isAllowedPdfOrImage(droppedFiles[0])) {
                    this.$message.error('仅支持 PDF 或图片格式！');
                    return;
                }
                this.uploadFile(droppedFiles[0], 9);
            }
            event.dataTransfer.value = '';
        },
        delCriminalRecord() {
            this.files.f9 = null;
        },
        /** 供身份证 OCR 使用；解析失败返回 ''，避免 Invalid date 导致日期选择器无法弹出 */
        normalizeBirthDateFromOcr(raw) {
            if (raw == null || raw === '') return '';
            const s = String(raw).trim();
            if (s === '' || s.toLowerCase() === 'null' || s.toLowerCase() === 'undefined') return '';
            if (/^\d{8}$/.test(s)) {
                const m = this.$moment(s, 'YYYYMMDD', true);
                return m.isValid() ? m.format('YYYY-MM-DD') : '';
            }
            const m1 = this.$moment(s, ['YYYY年M月D日', 'YYYY年MM月DD日'], true);
            if (m1.isValid()) return m1.format('YYYY-MM-DD');
            const m2 = this.$moment(s, ['YYYY-MM-DD', 'YYYY/MM/DD', 'YYYY.M.D', moment.ISO_8601], true);
            return m2.isValid() ? m2.format('YYYY-MM-DD') : '';
        },
        sanitizeOcrText(raw) {
            if (raw == null || raw === undefined) return '';
            let s = String(raw).trim();
            if (s === '' || s.toLowerCase() === 'null' || s.toLowerCase() === 'undefined') return '';
            s = s.replace(new RegExp('\\"', 'gi'), '').trim();
            return s;
        },
        /** 入学日期 + 学制年限 => 毕业日期；任一缺失则不计算 */
        calculateDepartureDateFromOcr(admissionDate, educationalSystem) {
            const admission = this.sanitizeOcrText(admissionDate);
            const system = this.sanitizeOcrText(educationalSystem);
            if (!admission || !system) {
                return null;
            }
            const yearsMatch = system.match(/(\d+)/);
            if (!yearsMatch) {
                return null;
            }
            const years = parseInt(yearsMatch[1], 10);
            if (isNaN(years) || years <= 0) {
                return null;
            }
            const start = this.$moment(admission, ['YYYY年MM月DD日', 'YYYY年M月D日', 'YYYY-MM-DD'], true);
            if (!start.isValid()) {
                return null;
            }
            return start.clone().add(years, 'years').startOf('year').format('YYYY-MM-DD');
        },
        applyAcademicRecordOcrToEdu(eduIndex, data) {
            if (eduIndex == null || !this.educationRecords[eduIndex] || !data) {
                return;
            }
            const institution = this.sanitizeOcrText(data.institution);
            const academic = this.sanitizeOcrText(data.academic);
            const major = this.sanitizeOcrText(data.major);
            if (institution) {
                this.$set(this.educationRecords[eduIndex], 'graduatedInstitution', institution);
            }
            this.syncEduReadonlyLock(eduIndex, 'graduatedInstitution', institution);

            if (academic) {
                this.$set(this.educationRecords[eduIndex], 'education', academic);
            }
            this.syncEduReadonlyLock(eduIndex, 'education', academic);

            if (major) {
                this.$set(this.educationRecords[eduIndex], 'major', major);
            }
            this.syncEduReadonlyLock(eduIndex, 'major', major);

            const departureDate = this.calculateDepartureDateFromOcr(data.admissionDate, data.educationalSystem);
            if (departureDate) {
                this.$set(this.educationRecords[eduIndex], 'departureDate', departureDate);
            }
            this.syncEduReadonlyLock(eduIndex, 'departureDate', departureDate);
        },
        getUserInfo: function (){
            if(Cookies.get('reqToKen')) {
                axios.get('/zhaopinapi/users/info', {
                    headers: {'Authorization': Cookies.get('reqToKen')}
                }).then((res) => {
                    let _d = res.data;
                    if (_d.success) {
                        this.userInfo = _d.data;
                        this.bmObj.userId = _d.data.id;
                        if (_d.data.phone) {
                            this.bmObj.phone = _d.data.phone;
                        }
                        this.evaluateEntranceOpenAccess();
                        if (!this.supplementMode) {
                            this.talentType = this.resolveTalentType(_d.data);
                            if (this.talentType !== null) {
                                this.bmObj.entrance_type = this.talentType;
                                this.ensureHighestEducationValid();
                                this.loadRecruitPositions();
                            }
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                })
            }
        },
        loadEntranceList() {
            return axios.get('/zhaopinapi/entrance/find-all').then((res) => {
                const ok = res.data && (res.data.success === true || res.data.code === 200);
                if (!ok) {
                    this.entryList = [];
                    return;
                }
                const raw = Array.isArray(res.data.data)
                    ? res.data.data
                    : (res.data.data && Array.isArray(res.data.data.records) ? res.data.data.records : []);
                this.entryList = raw.map((row) => ({
                    id: row.id,
                    entranceType: Number(row.entranceType),
                    entranceName: row.entranceName,
                    beginDate: row.beginDate,
                    endDate: row.endDate,
                }));
                this.evaluateEntranceOpenAccess();
            }).catch(() => {
                this.entryList = [];
            });
        },
        getCurrentEntrance() {
            const type = this.resolvedEntranceType;
            if (type === null || type === undefined || type === '') {
                return null;
            }
            return this.entryList.find((item) => item.entranceType === type) || null;
        },
        isEntranceInOpenTime(entry) {
            if (!entry || !entry.beginDate || !entry.endDate) {
                return true;
            }
            const now = this.$moment();
            const begin = this.$moment(entry.beginDate);
            const end = this.$moment(entry.endDate);
            return !now.isBefore(begin) && !now.isAfter(end);
        },
        evaluateEntranceOpenAccess() {
            const entry = this.getCurrentEntrance();
            if (!entry || this.isEntranceInOpenTime(entry)) {
                this.isEntranceOpen = true;
                return Promise.resolve();
            }
            const phone = this.userInfo && this.userInfo.phone;
            if (!phone) {
                this.isEntranceOpen = false;
                return Promise.resolve();
            }
            return axios.get('/zhaopinapi/users/is-admin-phone', {
                params: { phone },
            }).then((res) => {
                const isAdmin = res.data && (res.data.success === true || res.data.code === 200)
                    && res.data.data === true;
                this.isEntranceOpen = isAdmin;
            }).catch(() => {
                this.isEntranceOpen = false;
            });
        },
        resolveTalentType: function (user) {
            if (!user) return null;
            if (user.talentType != null && user.talentType !== '') {
                return Number(user.talentType);
            }
            if (user.entranceType != null && user.entranceType !== '') {
                return Number(user.entranceType);
            }
            if (user.entrance_type != null && user.entrance_type !== '') {
                return Number(user.entrance_type);
            }
            return null;
        },
        loadRecruitPositions: function () {
            if (this.talentType === null || !Cookies.get('reqToKen')) {
                return;
            }
            axios.get('/zhaopinapi/recruit-position-info/find-all', {
                headers: {'Authorization': Cookies.get('reqToKen')},
                params: {
                    talentType: this.talentType,
                    isDeleted: 0,
                }
            }).then((res) => {
                var _d = res.data;
                if (_d.success) {
                    const data = _d.data;
                    let list = [];
                    if (Array.isArray(data)) {
                        list = data;
                    } else if (data && Array.isArray(data.records)) {
                        list = data.records;
                    }
                    this.allJobList = this.normalizeRecruitList(list);
                    this.queryData.current = 1;
                    this.activeWorkTypeTab = '0';
                    this.resetWorkTypePagination();
                } else {
                    this.allJobList = [];
                }
            }).catch((error) => {
                console.log(error);
                this.allJobList = [];
            });
        },
        selectMajorCategory: function (cat) {
            this.selectedMajorCategory = cat;
            this.queryData.current = 1;
        },
        selectMajorName: function (name) {
            this.selectedMajorName = name;
            this.queryData.current = 1;
        },
        resetWorkTypePagination: function () {
            this.workTypePage = {0: 1, 1: 1};
        },
        resolveWorkTypeKey: function (workType) {
            if (workType === null || workType === undefined || workType === '') {
                return null;
            }
            const num = Number(workType);
            if (!isNaN(num) && (num === 0 || num === 1)) {
                return num;
            }
            const label = String(workType).trim();
            const keys = Object.keys(this.workTypeMap);
            for (let i = 0; i < keys.length; i++) {
                const key = Number(keys[i]);
                if (this.workTypeMap[key] === label) {
                    return key;
                }
            }
            return null;
        },
        getUndergraduateMajorName: function (item) {
            if (!item) {
                return '';
            }
            return item.undergraduateMajorName || item.undergraduate_major_name || item.majorName || '';
        },
        normalizeRecruitList: function (list) {
            if (!Array.isArray(list)) {
                return [];
            }
            return list.map((item) => {
                if (!item || typeof item !== 'object') {
                    return item;
                }
                return Object.assign({}, item, {
                    undergraduateMajorName: item.undergraduateMajorName || item.undergraduate_major_name || '',
                    undergraduateMajorCode: item.undergraduateMajorCode || item.undergraduate_major_code || '',
                    majorCategory: item.majorCategory || item.major_category || '',
                    majorName: item.majorName || item.major_name || '',
                    educationRequire: item.educationRequire || item.education_require || '',
                    graduationYearsRequirement: item.graduationYearsRequirement || item.graduation_years_requirement || '',
                    workType: this.resolveWorkTypeKey(item.workType != null ? item.workType : item.work_type),
                });
            });
        },
        onJobFilterChange: function () {
            this.queryData.current = 1;
        },
        workTypeLabel: function (workType) {
            if (workType === null || workType === undefined || workType === '') {
                return '';
            }
            return this.workTypeMap[workType] != null ? this.workTypeMap[workType] : workType;
        },
        formatEducation: function (val) {
            if (!val) {
                return '—';
            }
            const text = String(val).trim();
            if (text.indexOf('学历') !== -1 || text.indexOf('及以上') !== -1) {
                return text;
            }
            return text + '及以上学历';
        },
        formatCardTitle: function (item) {
            if (this.normalizedTalentType === 0) {
                const name = item.majorName || '';
                return name ? name : '—';
            }
            if (this.normalizedTalentType === 1) {
                return this.getUndergraduateMajorName(item) || '—';
            }
            return item.majorCategory || '—';
        },
        formatMajorRequirement: function (item) {
            if (this.normalizedTalentType === 0) {
                return item.majorCategory ? item.majorCategory + '相关专业' : '—';
            }
            if (this.normalizedTalentType === 1) {
                const name = this.getUndergraduateMajorName(item);
                return name ? name + '相关专业' : '—';
            }
            return item.majorCategory || '—';
        },
        getAllCity: function () {
            axios.get('/zhaopin/city.json', {
            }).then((res) => {
                this.citys = res.data;
            }).catch((error) => {
                console.log(error)
            })
        },
        handleProvinceChange: function (provinceName) {
            const selectedProvince = this.citys.find(item => item.name === provinceName);
            if (selectedProvince && selectedProvince.children) {
                this.currentCities = selectedProvince.children;
                this.bmObj.residentCity = '';
            } else {
                this.currentCities = [];
            }
            this.syncNativePlaceFromDropdown();
        },
        syncNativePlaceFromDropdown: function () {
            const parts = [this.bmObj.residentProvinceCity, this.bmObj.residentCity]
                .filter((value) => value != null && String(value).trim() !== '');
            this.bmObj.nativePlace = parts.join(' ');
        },
        changePage: function (currentPage) {
            if (this.normalizedTalentType === 2) {
                const key = Number(this.activeWorkTypeTab);
                this.$set(this.workTypePage, key, currentPage);
            } else {
                this.queryData.current = currentPage;
            }
        },
        formatOperationPositionDisplay(item) {
            if (!item) {
                return '—';
            }
            const name = String(
                item.majorCategory || item.major_category || item.majorName || item.major_name || ''
            ).trim();
            return name || '—';
        },
        openReg: function (item) {
            if (!item || item.id == null) {
                return;
            }
            if (!Cookies.get('reqToKen')) {
                this.$message.error('您还未登录！');
                return;
            }
            if (this.isRegisterDisabled) {
                if (!this.isEntranceOpen) {
                    this.$message.error('当前不在报名开放时间内，无法报名');
                } else if (this.isBm) {
                    this.$message.error('您已经报名了，不可重复报名哦！');
                }
                return;
            }
            const title = this.formatCardTitle(item);
            const id = item.id;
            if (this.userInfo.roleId == 2) {
                this.dialogVisible = true;
                this.dialogTitle = '申请专业：' + title;
                this.genderManuallySet = false;
                this.bmObj.politicalStatus = null;
                this.bmObj.recruitPositionInfoId = id;
                this.bmObj.positionId = id;
                if (this.normalizedTalentType === 2) {
                    this.bmObj.workType = this.resolveWorkTypeKey(
                        item.workType != null ? item.workType : this.activeWorkTypeTab
                    );
                    this.bmObj.majorCategory = item.majorCategory || '';
                    this.bmObj.positionsName = title;
                } else {
                    this.bmObj.workType = null;
                    this.bmObj.majorCategory = '';
                    this.bmObj.positionsName = title;
                }
                if (this.talentType !== null) {
                    this.bmObj.entrance_type = this.talentType;
                }
                this.ensureHighestEducationValid();
                if (this.userInfo.phone) {
                    this.bmObj.phone = this.userInfo.phone;
                }
                if (this.bmObj.highestEducation) {
                    this.initEducationRecords();
                }
            }
        },
        closeReg: function (done) {
            if (this.submitting) {
                return;
            }
            this.dialogVisible = false;
            if (typeof done === 'function') {
                done();
            }
        },
        async uploadFile(f, _type, eduIndex) {
            if (!f) {
                alert('请选择一个文件！');
                return;
            }
            var options = {
                bucket: 'webimg',
                expiration: Math.floor(new Date().getTime() / 1000) + 86400,
                'save-key': '/luanZp/{year}/{mon}/{day}/upload_{random32}{.suffix}'
            };
            var policy = window.btoa(JSON.stringify(options));
            var signature = md5(policy + '&' + 'dpNJGtx3fMUHooMfVfaPqofJbFE=');

            const formData = new FormData();
            formData.append('file', f); // 将文件添加到表单数据中
            formData.append('key', f.name); // 设置你的对象键（例如文件名）
            formData.append('policy', policy); // 设置你的策略，通常是base64编码的JSON策略字符串
            formData.append('OSSAccessKeyId', 'mp12345.com'); // 你的Access Key ID
            formData.append('signature', signature); // 签名，使用Access Key Secret和策略生成的签名

            return await axios.post('https://v0.api.upyun.com/webimg', formData, {
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then(response => {
                response.data.url = response.data.url ? ('https://webimg.mp12345.com' + response.data.url) : response.data.url;
                response.data.fileName = f.name;
                if(_type == 1) {
                    this.files.f1 = response.data;
                    this.ocrIdCard(response.data.url);
                } else if(_type == 5) {
                    if (eduIndex != null && this.educationRecords[eduIndex]) {
                        this.$set(this.educationRecords[eduIndex], 'graduationCert', response.data);
                    } else {
                        this.files.f5 = response.data;
                    }
                } else if(_type == 6) {
                    if (eduIndex != null && this.educationRecords[eduIndex]) {
                        this.$set(this.educationRecords[eduIndex], 'degreeCert', response.data);
                    } else {
                        this.files.f6 = response.data;
                    }
                } else if(_type == 7) {
                    if (eduIndex != null && this.educationRecords[eduIndex]) {
                        this.$set(this.educationRecords[eduIndex], 'file', response.data);
                        if (this.isXuexinOcrEnabled(eduIndex)) {
                            this.ocrStudent(response.data.url, eduIndex);
                        } else {
                            this.$message.success('学籍报告已上传，请手动填写学历信息');
                        }
                    } else {
                        this.files.f7 = response.data;
                        this.ocrStudent(response.data.url);
                    }
                } else if(_type == 2 || _type == 3 || _type == 4) {
                    this.files['f'+_type] = response.data;
                } else if(_type == 9) {
                    this.files.f9 = response.data;
                } else if(_type == 10) {
                    if (eduIndex != null && this.educationRecords[eduIndex]) {
                        this.$set(this.educationRecords[eduIndex], 'studyAbroadCert', response.data);
                    }
                }
            })
            .catch(error => {
                // this.$message.error(error);
                console.log(error)
                return null; // 或者抛出错误，取决于你的需求
            });
        },
        workAdd: function () {
            this.work.push({jobDuties: '', companyName: '', startDate: '', endDate: '', jobDescription: ''});
        },
        familyAdd: function () {
            this.family.push({relationType: 2, name: '', mobile: '', workUnit: '', position: '', birthDate: '', isInLuan: 0},);
        },
        delWorkli: function (n) {
            this.work.splice(n,1);
        },
        delFamilyli: function (n) {
            this.family.splice(n,1);
        },
        upIdCard: function (event) {
            const _f = event.target.files[0];
            if(_f) {
                this.uploadFile(_f,1);
            }
            event.target.value = null;
        },
        upIdCardTz: function (event) {
            const droppedFiles = event.dataTransfer.files;
            if(droppedFiles.length > 1) {
                this.$message.error('身份证人像面只允许上传一个文件！');
            } else {
                this.uploadFile(droppedFiles[0],1);
            }
            event.dataTransfer.value = '';
        },
        upIdCard2: function (event) {
            const _f = event.target.files[0];
            if(_f) {
                this.uploadFile(_f,2);
            }
            event.target.value = null;
        },
        upIdCard2Tz: function (event) {
            const droppedFiles = event.dataTransfer.files;
            if(droppedFiles.length > 1) {
                this.$message.error('身份证国徽面只允许上传一个文件！');
            } else {
                this.uploadFile(droppedFiles[0],2);
            }
            event.dataTransfer.value = '';
        },
        upPhoto: function (event) {
            const _f = event.target.files[0];
            if(_f) {
                this.uploadFile(_f,3);
            }
            event.target.value = null;
        },
        upPhotoTz: function (event) {
            const droppedFiles = event.dataTransfer.files;
            if(droppedFiles.length > 1) {
                this.$message.error('头像只允许上传一个文件！');
            } else {
                this.uploadFile(droppedFiles[0],3);
            }
            event.dataTransfer.value = '';
        },
        /*upByz: function (event) {
            const _f = event.target.files[0];
            if(_f) {
                this.uploadFile(_f,5);
            }
            event.target.value = null;
        },
        upByzTz: function (event) {
            const droppedFiles = event.dataTransfer.files;
            if(droppedFiles.length > 1) {
                this.$message.error('毕业证只允许上传一个文件！');
            } else {
                this.uploadFile(droppedFiles[0],5);
            }
            event.dataTransfer.value = '';
        },
        upXwz: function (event) {
            const _f = event.target.files[0];
            if(_f) {
                this.uploadFile(_f,6);
            }
            event.target.value = null;
        },
        upXwzTz: function (event) {
            const droppedFiles = event.dataTransfer.files;
            if(droppedFiles.length > 1) {
                this.$message.error('学位证只允许上传一个文件！');
            } else {
                this.uploadFile(droppedFiles[0],6);
            }
            event.dataTransfer.value = '';
        },*/
        upXjz: function (event, eduIndex) {
            const _f = event.target.files[0];
            if(_f) {
                const fileName = _f.name;
                const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
                if(fileExtension !== 'pdf') {
                  this.$message.error('学信网学籍验证报告必须为PDF格式，不能是其他格式！');
                  event.target.value = null;
                  return;
                }
                this.uploadFile(_f, 7, eduIndex);
            }
            event.target.value = null;
        },
        upXjzTz: function (event, eduIndex) {
            const droppedFiles = event.dataTransfer.files;
            if(droppedFiles.length > 1) {
                this.$message.error('学信网学籍只允许上传一个文件！');
            } else {
                const fileName = droppedFiles[0].name;
                const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
                if(fileExtension !== 'pdf') {
                  this.$message.error('学信网学籍验证报告必须为PDF格式，不能是其他格式！');
                  event.dataTransfer.value = '';
                  return;
                }
                this.uploadFile(droppedFiles[0], 7, eduIndex);
            }
            event.dataTransfer.value = '';
        },
        delEduFile: function (eduIndex) {
            if (this.educationRecords[eduIndex]) {
                this.$set(this.educationRecords[eduIndex], 'file', null);
                this.$set(this.educationRecords[eduIndex], 'prefilledReadonly', {
                    graduatedInstitution: false,
                    major: false,
                    education: false,
                    departureDate: false,
                });
            }
        },
        delFile5: function () {
            this.files.f5 = null;
        },
        delFile6: function () {
            this.files.f6 = null;
        },
        delFile7: function () {
            this.files.f7 = null;
        },
        ocrIdCard: function (url) {
            if(Cookies.get('reqToKen')) {
                axios.get('/zhaopinapi/idCard', {
                    headers: {'Authorization': Cookies.get('reqToKen')},
                    params: {
                        path: url
                    }
                }).then((res) => {
                    var _d = res.data;
                    if (_d.success) {
                        for(let key in _d.data) {
                            if(key) {
                                _d.data[key] = _d.data[key] ? _d.data[key].replace(new RegExp('\\"', 'gi'), "") : '';
                            }
                        }
                        if (_d.data.name) {
                            this.bmObj.name = _d.data.name;
                        }
                        if (_d.data.sex && !this.genderManuallySet) {
                            const genderMap = {'男': 1, '女': 0, '其他': 2};
                            const parsed = genderMap[_d.data.sex];
                            if (parsed != null) {
                                this.bmObj.gender = parsed;
                            }
                        }
                        const birthDate = this.normalizeBirthDateFromOcr(_d.data.birthday);
                        if (birthDate) {
                            this.$set(this.bmObj, 'birthDate', birthDate);
                        }
                        if (_d.data.id_number) {
                            this.bmObj.idCardNumber = _d.data.id_number;
                            if (!birthDate) {
                                const fromId = this.normalizeBirthDateFromOcr(_d.data.id_number.substring(6, 14));
                                if (fromId) {
                                    this.$set(this.bmObj, 'birthDate', fromId);
                                }
                            }
                        }
                        if (_d.data.address) {
                            this.bmObj.address = _d.data.address;
                            const provinceMatch = _d.data.address.match(/(.*?省|.*?自治区|北京市|天津市|上海市|重庆市)/);
                            if (provinceMatch) {
                                this.bmObj.residentProvinceCity = provinceMatch[1];
                                this.handleProvinceChange(this.bmObj.residentProvinceCity);
                                const remainingAddress = _d.data.address.substring(provinceMatch[1].length);
                                const cityMatch = remainingAddress.match(/(.*?市|.*?区|.*?县|.*?旗)/);
                                if (cityMatch) {
                                    this.bmObj.residentCity = cityMatch[1];
                                }
                            }
                            this.syncNativePlaceFromDropdown();
                        }
                        this.$message.success('身份证信息已识别，可继续修改');
                    } else {
                        this.$message.warning(_d.message || '身份证识别失败，请手动填写');
                    }
                }).catch((error) => {
                    this.$message.warning('身份证识别失败，请手动填写');
                    console.log(error)
                })
            }else {
                this.$message.error('您还未登录！');
            }
        },
        ocrGraduation: function (url) {
            if(Cookies.get('reqToKen')) {
                axios.get('/zhaopinapi/graduation', {
                    headers: {'Authorization': Cookies.get('reqToKen')},
                    params: {
                        path: url
                    }
                }).then((res) => {
                    var _d = res.data;
                    if (_d.success) {
                        for(let key in _d.data) {
                            if(key) {
                                _d.data[key] = _d.data[key] ? _d.data[key].replace(new RegExp('\\"', 'gi'), "") : '';
                            }
                        }
                        this.bmObj.graduatedInstitution = _d.data.graduatedFrom;
                        this.syncReadonlyLock('graduatedInstitution', this.bmObj.graduatedInstitution);
                        this.bmObj.major = _d.data.major;
                        this.syncReadonlyLock('major', this.bmObj.major);
                        this.bmObj.education = _d.data.educational;
                        this.syncReadonlyLock('education', this.bmObj.education);
                    }
                }).catch((error) => {
                    // this.$message.error(error);
                    console.log(error)
                })
            }else {
                this.$message.error('您还未登录！');
            }
        },
        ocrStudent: function (url, eduIndex) {
            if(Cookies.get('reqToKen')) {
                axios.get('/zhaopinapi/graduation/academic-record-report', {
                    headers: {'Authorization': Cookies.get('reqToKen')},
                    params: {
                        path: url,
                        flag: 1
                    }
                }).then((res) => {
                    var _d = res.data;
                    if (_d.success && _d.data) {
                        if (eduIndex != null) {
                            this.applyAcademicRecordOcrToEdu(eduIndex, _d.data);
                            this.$message.success('学籍报告已识别，可继续修改');
                        }
                    } else {
                        this.$message.warning(_d.message || '学籍报告识别失败，请手动填写');
                    }
                }).catch((error) => {
                    this.$message.warning('学籍报告识别失败，请手动填写');
                    console.log(error);
                });
            }else {
                this.$message.error('您还未登录！');
            }
        },

        checkEnd: function (n) {
            if(this.work[n].now) {
                this.work[n].endDate = '2099-12-31';
            } else {
                this.work[n].endDate = moment(new Date()).format('yyyy-MM');
            }
        },
        buildEducationHistoryList() {
            return this.educationRecords.map((edu, index) => ({
                segmentOrder: index,
                segmentLabel: edu.label,
                graduatedInstitution: edu.graduatedInstitution,
                major: edu.major,
                majorCode: edu.majorCode || '',
                educationLevel: edu.education,
                departureDate: toGraduationYearStorage(edu.departureDate),
                isDomestic: edu.isDomestic,
                institutionType: edu.isDomestic === 1 ? edu.institutionType : '',
                qsRanking: edu.isDomestic === 0 ? edu.qsRanking : null,
            }));
        },
        getEntranceTypeLabel(entranceType) {
            const map = { 0: '优培人才', 1: '技术人才', 2: '操作人才' };
            const key = entranceType != null ? Number(entranceType) : null;
            return key != null && map[key] != null ? map[key] : '该入口';
        },
        ensureNotDuplicateEntranceApplication() {
            const idCardNumber = (this.bmObj.idCardNumber || '').trim();
            const entranceType = this.resolvedEntranceType;
            if (!idCardNumber) {
                this.$message.error('身份证号不能为空！');
                return Promise.resolve(false);
            }
            if (entranceType === null || entranceType === undefined || entranceType === '') {
                this.$message.error('报名入口信息缺失，请重新登录后再试');
                return Promise.resolve(false);
            }
            if (!Cookies.get('reqToKen')) {
                this.$message.error('您还未登录！');
                return Promise.resolve(false);
            }
            return axios.get('/zhaopinapi/job-applications/check-entrance-applied', {
                headers: { Authorization: Cookies.get('reqToKen') },
                params: { entranceType, idCardNumber },
            }).then((res) => {
                const data = res.data;
                if (!data || !data.success) {
                    this.$alert((data && data.message) || '校验报名信息失败，请稍后重试', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                    });
                    return false;
                }
                if (data.data === true) {
                    const label = this.getEntranceTypeLabel(entranceType);
                    this.$alert(
                        `该身份证号已在「${label}」报过名（含审批通过、审批不通过等状态），不可重复报名。`,
                        '提示',
                        { confirmButtonText: '确定', type: 'warning' },
                    );
                    return false;
                }
                return true;
            }).catch((error) => {
                const msg = (error.response && error.response.data && error.response.data.message)
                    || '校验报名信息失败，请稍后重试';
                this.$alert(msg, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                });
                console.log(error);
                return false;
            });
        },
        createBm: async function () {
            if (this.submitting) {
                return false;
            }
            if (!(await this.validateBmForm())) {
                return false;
            }
            if (this.supplementMode) {
                if (this.isSupplementSubmitDisabled) {
                    this.$message.error('当前不在报名开放时间内，无法提交补充资料');
                    return false;
                }
                this.resubmitSupplement();
                return;
            }
            if (!this.isEntranceOpen) {
                this.$message.error('当前不在报名开放时间内，无法报名');
                return false;
            }
            const canSubmit = await this.ensureNotDuplicateEntranceApplication();
            if (!canSubmit) {
                return false;
            }
            try {
                await this.$confirm(
                    '请确认信息正确，提交后信息无法修改，是否确认提交？',
                    '提示',
                    {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }
                );
            } catch {
                return false;
            }
            this.buildSubmissionPayload();
            this.submitting = true;
            axios.post('/zhaopinapi/job-applications', this.bmObj,{
                headers: {'Authorization': Cookies.get('reqToKen')}
            }).then((res) => {
                let _d = res.data;
                if(_d.success) {
                    this.dialogVisible = false;
                    this.loadApplicationStats();
                    this.regSuccessDialogVisible = true;
                } else {
                    const failMsg = _d.message || '报名失败';
                    this.$alert(failMsg, '提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                    });
                }
            }).catch((error) => {
                const msg = (error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : '报名失败，请稍后重试';
                this.$alert(msg, '提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                });
                console.log(error);
            }).finally(() => {
                this.submitting = false;
            });
        },
        goToMyJobAfterReg: function () {
            this.regSuccessDialogVisible = false;
            this.$router.push('/pageMyjob');
        },
        getJobInfo: function () {
            if(Cookies.get('reqToKen')) {
                axios.get('/zhaopinapi/job-applications/currently', {
                    headers: {'Authorization': Cookies.get('reqToKen')},
                }).then((res) => {
                    let _d = res.data;
                    if (_d.success) {
                        this.isBm = (_d.data && _d.data.id) ? 1 : 0;
                    }
                }).catch((error) => {
                    this.$message({
                        message: '未查询到报名信息，你可以报名。',
                        type: 'success'
                    });
                    console.log(error);
                    // this.$router.push('/pageIndex');
                })
            }
        },
        loadApplicationStats: function () {
            const talentType = this.normalizedTalentType;
            if (talentType === null || talentType === undefined || talentType === '') {
                return;
            }
            const params = { talentType: talentType };
            if (talentType === 0 && this.selectedMajorCategory) {
                params.majorCategory = this.selectedMajorCategory;
            } else if (talentType === 1 && this.selectedMajorName) {
                params.majorName = this.selectedMajorName;
            }
            const headers = {};
            if (Cookies.get('reqToKen')) {
                headers.Authorization = Cookies.get('reqToKen');
            }
            axios.get('/zhaopinapi/job-applications/statistics/summary', {
                params: params,
                headers: headers,
            }).then((res) => {
                let _d = res.data;
                if (_d.success && _d.data) {
                    this.curCompN.bm = _d.data.totalApplications != null ? _d.data.totalApplications : 0;
                    this.curCompN.sp = _d.data.reviewedApplications != null ? _d.data.reviewedApplications : 0;
                } else {
                    this.curCompN.bm = 0;
                    this.curCompN.sp = 0;
                }
            }).catch((error) => {
                console.log(error);
                this.curCompN.bm = 0;
                this.curCompN.sp = 0;
            });
        },
    }
}
</script>

<style scoped>
    .jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
    @media (max-width: 1400px) and (min-width: 1300px) {
        .jobMain{width: 90%;  margin: 0 auto;}
    }
    @media (max-width: 1300px) {
        .jobMain{width: 100%; min-width: 1150px;}
    }
    .pageRegisterLink{}
    .page-head{padding: 24px 0; background-color: #fff;}
    .page-tle{font-size: 20px; color: #101828; font-weight: bold; line-height: 30px; padding-left: 36px;}
    .iconStyle{color: #E7000B; font-size: 24px; margin-right: 10px; vertical-align: middle;}
    .pageReg-main{padding-top: 24px; padding-bottom: 50px;}
    .pageReg-ml{border-radius: 14px; padding-bottom: 14px; border: 1px solid #E5E7EB; background: #FFF; box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);}
    .pageReg-ml-t--select{height: auto; min-height: 95px; padding-bottom: 16px;}
    .jobLi--tech{height: auto; min-height: 270px;}
    .pageReg-ml-t{height: 95px; padding: 16px 16px 1px 16px; border-bottom: 1px solid #F3F4F6; background: rgba(249, 250, 251, 0.50);}
    .pageReg-ml-tle{color: #6A7282; font-size: 14px; font-weight: 700; line-height: 30px;}
    .pageReg-ml-list{padding: 8px 8px 0 8px; height: 920px; overflow-y: auto;}
    .pageReg-ml-list::-webkit-scrollbar{width:6px; height:6px; background-color:#FEF2F2; border-radius: 3px;}
    /*定义滚动条的轨道，内阴影及圆角*/
    .pageReg-ml-list::-webkit-scrollbar-track{background-color:#FEF2F2; border-radius: 3px;}
    /*定义滑块，内阴影及圆角*/
    .pageReg-ml-list::-webkit-scrollbar-thumb{height:6px;border-radius:3px;background-color:#FB2C36; filter:alpha(Opacity=50);-moz-opacity:0.5;opacity:0.5;}
    .pageReg-ml-list ul{margin: 0; padding: 0; list-style: none;}
    .pageReg-ml-list ul li{height: 46px; line-height: 46px; padding: 0 16px; cursor: pointer; font-size: 14px; overflow: hidden;}
    .pageReg-ml-list ul li:hover{border-radius: 10px; color: #C10007; font-weight: 600; background: url("../assets/images/pageReg-ml-icon.png") no-repeat calc(100% - 16px) center #FEF2F2; box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10);}
    .pageReg-ml-list ul li.active{border-radius: 10px; color: #C10007; font-weight: 600; background: url("../assets/images/pageReg-ml-icon.png") no-repeat calc(100% - 16px) center #FEF2F2; box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10);}
    .pageReg-banner{height: 124px; padding: 136px 35px 0 35px; background: url("../assets/images/pageReg-banner.png") no-repeat center top; background-size: 100% 100%; border-top-left-radius: 10px; border-top-right-radius: 10px;}
    .pageReg-banner-left{width: 60%; float: left; padding-top: 20px;}
    .pageReg-banner-right{width: 150px; float: right;}
    .pageReg-banner-lname{font-size: 30px; font-weight: 400; line-height: 36px; color: #fff; padding-bottom: 10px;}
    .pageReg-banner-lb{color: #fff; line-height: 30px;}
    .pageReg-banner-num{border-radius: 4px; padding: 0 12px; line-height: 24px; border: 1px solid #E5E7EB; background: #F3F4F6; color: #4A5565; font-size: 12px; display: inline-block; margin-left: 10px;}
    .pageReg-banner-rt{font-size: 12px; color: #fff; line-height: 30px; text-align: right;}
    .pageReg-banner-tel{height: 30px; line-height: 30px; color: #fff; border-radius: 15px; padding: 0 15px; margin-bottom: 8px; border: 1px solid rgba(255, 255, 255, 0.10); background: rgba(255, 255, 255, 0.10);}
    .pageReg-rm{padding: 32px; background-color: #fff;}
    .pageReg-rmt{height: 24px; line-height: 24px; font-size: 16px; color: #1E2939; font-weight: bold; padding-left: 16px; border-left: 4px solid #E7000B; margin-bottom: 16px;}
    .pageReg-work-tabs{margin-bottom: 20px;}
    .pageReg-work-tabs >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner{
        background-color: #E7000B;
        border-color: #E7000B;
        box-shadow: -1px 0 0 0 #E7000B;
    }
    .pageReg-rm-intro{border-radius: 10px; border: 1px solid #F3F4F6; background: #F9FAFB; color: #4A5565; line-height: 24px; padding: 24px; margin-bottom: 40px;}
    .jobNum{height: 20px; line-height: 20px; border-radius: 20px; background: #FFE2E2; padding: 0 6px; color: #C10007; margin-left: 10px; font-size: 14px;}
    .jobLi{min-height: 270px; height: auto; border-radius: 14px; border: 1px solid #E5E7EB; background: #FFF; box-sizing: border-box; padding: 20px; margin-bottom: 20px;}
    .jobLi-tle{font-size: 18px; color: #101828; line-height: 28px; font-weight: bold;}
    .tagParent{padding: 8px 0;}
    .tagDom{height: 22px; line-height: 18px;}
    .pageReg-bm-btn{height: 40px; width: 100%; border: none; line-height: 40px; font-weight: bold; color: #E7000B; text-align: center; border-radius: 10px; background: #FEF2F2; cursor: pointer;}
    .pageReg-bm-btn:hover{background: #fddddd;}
    .pageReg-bm-btn--disabled,
    .pageReg-bm-btn:disabled{color: #99A1AF; background: #F3F4F6; cursor: not-allowed;}
    .pageReg-bm-btn--disabled:hover,
    .pageReg-bm-btn:disabled:hover{background: #F3F4F6;}
    .supplement-closed-tip{margin-top: 12px; color: #99A1AF; font-size: 14px; line-height: 20px;}
    .jobLi-condition-row{display: flex; flex-wrap: wrap; align-items: stretch;}
    .jobLi-condition-row ::v-deep > .el-col{display: flex;}
    .job-condition{flex: 1; width: 100%; min-height: 34px; display: flex; flex-direction: column; padding: 8px 0 16px 0; border-bottom: 1px solid #F3F4F6; box-sizing: border-box;}
    .job-condition-t{font-size: 12px; color: #99A1AF; line-height: 14px; flex-shrink: 0;}
    .job-icon{font-size: 12px; color: #99A1AF;}
    .job-condition-b{flex: 1; font-size: 12px; color: #364153; font-weight: bold; line-height: 16px; padding-right: 10px; min-height: 16px; word-break: break-word; overflow-wrap: break-word;}

    .dragDom{padding: 20px 0; border: 2px dashed #D9D9D9; text-align: center; margin-bottom: 15px; position: relative;}
    .dragDomP{width: 100%; height: 100%; position: absolute; left: 0; top: 0;}
    .dragDomP img{width: 100%; height: 100%;}
    .dragDom-t1{color: #323232; font-size: 26px; font-weight: 500; line-height: 32px;}
    .dragDom-t2{padding: 16px 0; text-align: center;}
    .dragDom-t3{font-size: 14px; color: #3E3E3E; text-align: center; line-height: 20px;}
    .uploadBtn-dom{width: 130px; height: 48px; margin: 0 auto; position: relative; overflow: hidden;}
    .uploadBtn-dom input{width: 600px; height: 200px; font-size: 200px; position: absolute; right: 0; top: 0; z-index: 2; opacity: 0; filter: alpha(opacity=0); cursor: pointer;}
    .uploadBtn{width: 130px; height: 48px; line-height: 48px; border-radius: 3px; border: 1px solid #FF1616; background: #E60012; color: #fff; font-size: 16px; cursor: pointer;}
    .uploadBtn:hover{background-color: #C10007;}
    .dragDom-file{text-align: left; padding: 20px;}
    .fileShow{color: #007bff; text-decoration: none;}
    .fileDel{margin-left: 20px; color: #E7000B;}

    .regJob-dom{padding: 0 20px;}
    .edu-section{margin-bottom: 8px;}
    .edu-cert-block{margin-top: 16px;}
    .edu-cert-drag .dragDom-t1{font-size: 20px;}
    .regJob-tle{line-height: 30px; font-size: 28px; color: #323232; padding: 16px 0;}
    .regJob-b{padding-top: 16px; border-top: 1px solid #D9D9D9;}
    .regJob-b1{padding: 16px; border: 1px solid #D9D9D9; position: relative; margin-bottom: 10px;}
    .listClose{position: absolute; right: 5px; top: 5px; z-index: 9; font-size: 18px; color: #E7000B; cursor: pointer;}
    .regJob-form-t{font-size: 14px; line-height: 20px;}
    .regJob-form-b{padding-bottom: 16px;}
    .red{color: #E7000B;}
    .addDom{color: #E7000B; font-size: 14px; font-weight: bold; line-height: 20px; cursor: pointer;}
    .form-fjli{line-height: 24px; padding: 8px 16px; border: 1px solid #D9D9D9; background: #F7F7F7; margin-bottom: 10px;}
    .form-fjli-l{float: left; line-height: 24px; color: #333; font-size: 16px;}
    .form-fjli-r{float: right; line-height: 24px; color: #333; font-size: 16px; cursor: pointer;}

    .el-radio .el-radio__label{white-space: normal !important; word-break: break-all !important;}

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #E7000B; /* 设置你想要的背景色 */
        color: white; /* 设置文字颜色 */
    }
    .clearfix:after,.clearfix:before{
        clear: both;
        content: "";
        display: block;
        line-height: 0;
    }
</style>

<style>
.pageRegisterLink--supplement {
    background: transparent;
    width: 100%;
}
.pageRegisterLink--supplement .supplement-form-panel {
    width: 100%;
    border: 1px solid #E5E7EB;
    border-radius: 12px;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.pageRegisterLink--supplement .supplement-form-toolbar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
    padding: 10px 16px;
    border-bottom: 1px solid #F3F4F6;
    background: #FAFAFA;
}
.pageRegisterLink--supplement .supplement-form-title {
    font-size: 14px;
    font-weight: 700;
    color: #101828;
}
.pageRegisterLink--supplement .supplement-form-major {
    font-size: 13px;
    color: #6A7282;
}
.pageRegisterLink--supplement .supplement-form-scroll {
    max-height: min(560px, calc(100vh - 380px));
    overflow-x: hidden;
    overflow-y: auto;
    padding: 12px 20px;
}
.pageRegisterLink--supplement .supplement-form-scroll::-webkit-scrollbar {
    width: 6px;
}
.pageRegisterLink--supplement .supplement-form-scroll::-webkit-scrollbar-thumb {
    background: #D1D5DC;
    border-radius: 3px;
}
.pageRegisterLink--supplement .supplement-form-footer {
    padding: 12px 16px 16px;
    border-top: 1px solid #F3F4F6;
    background: #FAFAFA;
    text-align: center;
}
.pageRegisterLink--supplement .supplement-commitment {
    padding: 0 0 12px !important;
    text-align: left;
    font-size: 13px;
    line-height: 20px;
}
.pageRegisterLink--supplement .supplement-form-footer .el-button--danger {
    min-width: 200px;
    height: 40px;
    font-size: 15px;
    font-weight: 600;
}

/deep/ .reg-success-dialog .el-dialog__header {
    background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
    border-bottom: 1px solid #bbf7d0;
    padding: 16px 20px;
}
/deep/ .reg-success-dialog .el-dialog__title {
    font-size: 20px;
    font-weight: 700;
    color: #15803d;
}
/deep/ .reg-success-dialog .el-dialog__body {
    padding: 0 0 8px;
}
.reg-success-subtitle {
    margin: 0;
    padding: 16px 28px;
    text-align: center;
    font-size: 17px;
    color: #E7000B;
    font-weight: 700;
    line-height: 26px;
    background: #fef2f2;
    border-bottom: 1px solid #fecaca;
}
.reg-success-body {
    padding: 20px 28px 0;
}
.reg-success-head {
    text-align: center;
    padding-bottom: 20px;
}
.reg-success-icon {
    font-size: 52px;
    color: #67C23A;
    line-height: 1;
}
.reg-success-title {
    margin-top: 12px;
    font-size: 22px;
    font-weight: 700;
    color: #101828;
    line-height: 32px;
}
.reg-success-flow {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 4px;
    padding: 16px 8px;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
}
.reg-success-step {
    flex: 1;
    min-width: 0;
    text-align: center;
    padding: 10px 6px;
    border-radius: 10px;
    background: #fff;
    border: 1px solid #e5e7eb;
}
.reg-success-step--done {
    border-color: #bbf7d0;
    background: #f0fdf4;
}
.reg-success-step--active {
    border-color: #fca5a5;
    background: #fef2f2;
    box-shadow: 0 0 0 1px rgba(231, 0, 11, 0.08);
}
.reg-success-step-num {
    width: 24px;
    height: 24px;
    margin: 0 auto 8px;
    border-radius: 50%;
    background: #E7000B;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    line-height: 24px;
}
.reg-success-step--done .reg-success-step-num {
    background: #67C23A;
}
.reg-success-step-text {
    font-size: 12px;
    line-height: 18px;
    color: #364153;
    font-weight: 600;
}
.reg-success-step-tag {
    margin-top: 6px;
    font-size: 11px;
    color: #67C23A;
    font-weight: 600;
}
.reg-success-arrow {
    display: flex;
    align-items: center;
    color: #99A1AF;
    font-size: 16px;
    flex-shrink: 0;
}
.reg-success-tip {
    margin-top: 18px;
    padding: 12px 14px;
    border-radius: 8px;
    background: #fff7ed;
    border: 1px solid #fed7aa;
    color: #9a3412;
    font-size: 14px;
    line-height: 22px;
    white-space: nowrap;
    overflow-x: auto;
}
.reg-success-tip i {
    margin-right: 6px;
    color: #ea580c;
}
</style>
